<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- 受注データ取込詳細画面 -->
      <!-- 基本情報  -->
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="dataImportEditForm"
          label-position="right"
          :label-width="$t('widgetSize.ACCEPT_ORDER_INFO.DETIAL_LABEL_WIDTH')"
        >
          <!-- ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓ -->
          <t-collapse v-model="activeNames" @change="handleCollapseChange">
            <t-collapse-item title="取込基本情報" name="dataImportBasic">
              <!-- ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑ -->
              <t-row>
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- 取込担当者 -->
                <t-col :span="colArr.colCom">
                  <t-form-item :label="$t('resource.DATA_IMPORT.CONTACTER')">
                    <t-select
                      v-model="dataImportEditForm.dibUserCode"
                      style="width: 100%"
                      :disabled="
                        this.dataImportTable.length > 0 || userNullFlag
                      "
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in userList"
                        :key="item.UserId"
                        :label="item.UserName"
                        :value="item.UserId"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>
                <!-- 取込時間 -->
                <t-col :span="colArr.colCom">
                  <t-form-item :label="$t('resource.DATA_IMPORT.IMPORT_TIME')">
                    <t-date-picker
                      v-model="dataImportEditForm.dibImportTime"
                      class="dialogDate"
                      :clearable="false"
                      type="date"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd HH:mm:ss"
                      disabled
                    ></t-date-picker>
                  </t-form-item>
                </t-col>
                <!-- 状態 -->
                <t-col :span="colArr.colCom">
                  <t-form-item :label="$t('resource.DATA_IMPORT.STATUS')">
                    <t-select
                      v-model="dataImportEditForm.dibAcceptState"
                      style="width: 100%"
                      placeholder=""
                      disabled
                    >
                      <t-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>

              <t-row>
                <t-col :span="colArr.colL">&nbsp;</t-col>
                <!-- ファイル名 -->
                <t-col :span="`24` - colArr.colL - colArr.colCom - colArr.colR">
                  <t-form-item :label="$t('resource.DATA_IMPORT.FILE_NAME')">
                    <t-input v-model="dataImportEditForm.dibFileName" disabled>
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :span="colArr.colR">&nbsp;</t-col>
              </t-row>
              <!-- UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓ -->
            </t-collapse-item>
          </t-collapse>
          <!-- UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑ -->
        </t-form>
      </div>

      <div>
        <t-row>
          <t-col>
            <div style="padding: 10px 0">
              <t-row>
                <t-col :span="4" class="col_common_left">
                  <!-- 受注データ取込ボタン -->
                  <t-button
                    round
                    type="primary"
                    style="margin-top: 10px"
                    class="dialogButton_180_40"
                    ref="dataImportBtn"
                    @click="dataImportClick()"
                    :disabled="
                      (dataImportTable.length > 0 && !notAcceptedFlg) ||
                      userNullFlag
                    "
                  >
                    <i class="el-icon-plus"></i
                    >{{
                      $t("resource.DATA_IMPORT.DATA_IMPORT_INFORMATION_BUTTON")
                    }}
                  </t-button>
                </t-col>
                <t-col :span="20" class="col_common_left">
                  <!-- 削除ボタン -->
                  <t-button
                    round
                    type="danger"
                    style="margin-top: 10px"
                    class="button_common"
                    ref="delBtn"
                    @click="deleteClick()"
                    :disabled="acceptedFlg || localIsAdd || userNullFlag"
                  >
                    <i class="el-icon-delete"></i>
                    {{ $t("resource.sys.delete") }}
                  </t-button>
                </t-col>
              </t-row>

              <!-- 受注データ取込詳細のテーブル -->
              <div>
                <t-table
                  ref="dataImportTable"
                  :data="dataImportTable"
                  class="table_common"
                  header-cell-class-name="bg-default"
                  :height="detailHeight"
                  highlight-current-row
                  :cell-class-name="tableCellClassName"
                  border
                  fit
                >
                  <!-- テーブルの列 -->
                  <!-- UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓ -->
                  <!-- <t-table-column
                    v-for="(column, index) in columns"
                    :key="index"
                    :type="column.type"
                    :prop="column.prop"
                    :label="column.label"
                    :min-width="column.width"
                    :class-name="column.class"
                    :fixed="column.fixed"
                    :show-overflow-tooltip="column.overflowTooltip"
                  >
                   <template
                      v-if="column.children && column.children.length > 0"
                    >
                      <t-table-column
                        v-for="(columnSon, indexSon) in column.children"
                        :key="indexSon"
                        :type="columnSon.type"
                        :prop="columnSon.prop"
                        :label="columnSon.label"
                        :min-width="columnSon.width"
                        :class-name="columnSon.class"
                        :show-overflow-tooltip="columnSon.overflowTooltip"
                      >
                        <template #default="scopeChildren"> -->
                  <!--text   -->
                  <!-- <t-input
                            :class="columnSon.class"
                            v-if="
                              editCellData(
                                scopeChildren.row,
                                scopeChildren.column
                              ) == 'text'
                            "
                            v-model="scopeChildren.row[columnSon.prop]"
                            @blur="changeCellData()"
                            @focus="selectValue($event)"
                            :maxLength="columnSon.maxLength"
                            :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                            @keyup.native.enter="
                              focusNextInput(
                                scopeChildren.row.index,
                                columnSon.prop
                              )
                            "
                            :disabled="!notAcceptedFlg || userNullFlag"
                          /> -->
                  <!--input-->
                  <!-- <t-input
                            class="cell_input_custom"
                            v-else-if="
                              editCellData(
                                scopeChildren.row,
                                scopeChildren.column
                              ) == 'input'
                            "
                            v-model="scopeChildren.row[columnSon.prop]"
                            @blur="changeCellData()"
                            :maxLength="columnSon.maxLength || 8"
                            :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                            @keyup.native.enter="
                              focusNextInput(
                                scopeChildren.row.index,
                                columnSon.prop
                              )
                            "
                            @focus="selectValue($event)"
                            oninput="value=value.replace(/[^\d.]/g,'').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') "
                            :disabled="!notAcceptedFlg || userNullFlag"
                          /> -->
                  <!--input-number-->
                  <!-- <t-input-number
                            class="cell_input_number"
                            v-else-if="
                              editCellData(
                                scopeChildren.row,
                                scopeChildren.column
                              ) == 'inputNumber'
                            "
                            :controls="false"
                            :precision="columnSon.precision || 0"
                            :min="0"
                            :max="columnSon.max || 999999"
                            v-model="scopeChildren.row[columnSon.prop]"
                            :maxLength="6"
                            @blur="changeCellData()"
                            @focus="selectValue($event)"
                            :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                            @keyup.native.enter="
                              focusNextInput(
                                scopeChildren.row.index,
                                columnSon.prop
                              )
                            "
                            :disabled="!notAcceptedFlg || userNullFlag"
                          /> -->
                  <!--select-->
                  <!-- <t-select
                            placeholder=""
                            class="commonDialog"
                            v-else-if="
                              editCellData(
                                scopeChildren.row,
                                scopeChildren.column
                              ) == 'selectCusUser'
                            "
                            v-model="scopeChildren.row[columnSon.prop]"
                            :disabled="!notAcceptedFlg || userNullFlag"
                          > -->
                  <!-- -->
                  <!--  <t-option
                              v-for="item in scopeChildren.row.managerList"
                              :key="item.mgrCode"
                              :label="item.mgrAbbreviation"
                              :value="item.mgrCode"
                            >
                            </t-option>
                          </t-select> -->
                  <!--select-->
                  <!-- <t-select
                            placeholder=""
                            class="commonDialog"
                            v-else-if="
                              editCellData(
                                scopeChildren.row,
                                scopeChildren.column
                              ) == 'selectCustomer'
                            "
                            @change="changeSelectCustomer(scopeChildren.row)"
                            v-model="scopeChildren.row[columnSon.prop]"
                            :disabled="!notAcceptedFlg || userNullFlag"
                          >
                            <t-option
                              v-for="item in customerList"
                              :key="item.cusCode"
                              :label="item.cusCode + ':' + item.cusAbbreviation"
                              :value="item.cusCode"
                            >
                            </t-option>
                          </t-select> -->
                  <!--select-->
                  <!-- <t-select
                            placeholder=""
                            class="commonDialog"
                            v-else-if="
                              editCellData(
                                scopeChildren.row,
                                scopeChildren.column
                              ) == 'selectSupplier'
                            "
                            clearable
                            @change="
                              changeSelectSupplier(
                                scopeChildren.row,
                                scopeChildren.column
                              )
                            "
                            v-model="scopeChildren.row[columnSon.prop]"
                            :disabled="!notAcceptedFlg || userNullFlag"
                          >
                            <t-option
                              v-for="item in getSupplierList(columnSon.prop)"
                              :key="item.supCode"
                              :label="item.supCode + ':' + item.supAbbreviation"
                              :value="item.supCode"
                            >
                            </t-option>
                          </t-select>
                          <span v-else>
                            {{ scopeChildren.row[columnSon.prop] }}
                          </span>
                        </template>
                      </t-table-column>
                    </template> -->
                  <!-- ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓ -->

                  <template v-for="(column, index) in leftColumns">
                    <t-table-column
                      :key="'l-' + index"
                      :type="column.type"
                      :prop="column.prop"
                      :label="column.label"
                      :min-width="column.width"
                      :class-name="column.class"
                      :fixed="index < 4"
                      :show-overflow-tooltip="column.overflowTooltip"
                    >
                      <template v-slot:default="leftScope">
                        <div
                          v-if="
                            column.grandChildren && column.grandChildren.length
                          "
                          class="combined-cell"
                        >
                          <div
                            v-for="(
                              columnGrandSon, gIndex
                            ) in column.grandChildren"
                            :key="gIndex"
                            :style="{
                              backgroundColor: tableCellClassName,
                            }"
                          >
                            <span>{{
                              leftScope.row[columnGrandSon.property]
                            }}</span>
                          </div>
                        </div>
                        <template v-else>
                          <span>
                            {{ leftScope.row[column.prop] }}
                          </span>
                        </template>
                      </template>
                    </t-table-column>
                  </template>
                  <!-- ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑ -->
                  <template v-for="(column, index) in columns">
                    <!-- テーブルの列 -->
                    <t-table-column
                      v-if="column.children && column.children.length > 0"
                      :key="index"
                      :type="column.type"
                      :prop="column.prop"
                      :label="column.label"
                      :min-width="column.width"
                      :class-name="column.class"
                      :fixed="column.fixed"
                      :show-overflow-tooltip="column.overflowTooltip"
                    >
                      <template
                        v-for="(columnSon, indexSon) in column.children"
                      >
                        <t-table-column
                          :key="indexSon"
                          :type="columnSon.type"
                          :prop="columnSon.prop"
                          :label="columnSon.label"
                          :min-width="columnSon.width"
                          :class-name="columnSon.class"
                          :show-overflow-tooltip="columnSon.overflowTooltip"
                        >
                          <template v-slot:default="scopeChildren">
                            <div
                              v-if="
                                columnSon.grandChildren &&
                                columnSon.grandChildren.length > 0
                              "
                              class="combined-cell"
                            >
                              <div
                                v-for="(
                                  columnGrandSon, indexGrandSon
                                ) in columnSon.grandChildren"
                                :key="indexGrandSon"
                                :style="{
                                  backgroundColor: tableCellClassName,
                                }"
                              >
                                <t-input
                                  v-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) === 'text'
                                  "
                                  class="cell_input_custom cell_input_font_small"
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  @blur="changeCellData()"
                                  @focus="selectValue($event)"
                                  :maxLength="columnGrandSon.maxLength"
                                  :ref="`input${scopeChildren.row.index}-${columnGrandSon.property}`"
                                  @keyup.native.enter="
                                    focusNextInput(
                                      scopeChildren.row.index,
                                      columnGrandSon.property
                                    )
                                  "
                                  :disabled="!notAcceptedFlg || userNullFlag"
                                />
                                <t-input
                                  class="cell_input_custom cell_input_font_small"
                                  v-else-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) == 'input'
                                  "
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  @blur="changeCellData()"
                                  :maxLength="columnGrandSon.maxLength || 8"
                                  :ref="`input${scopeChildren.row.index}-${columnGrandSon.property}`"
                                  @keyup.native.enter="
                                    focusNextInput(
                                      scopeChildren.row.index,
                                      columnGrandSon.property
                                    )
                                  "
                                  @focus="selectValue($event)"
                                  oninput="value=value.replace(/[^\d.]/g,'').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') "
                                  :disabled="
                                    !notAcceptedFlg ||
                                    userNullFlag ||
                                    inputEnableCheck(
                                      scopeChildren.row,
                                      columnGrandSon
                                    )
                                  "
                                />
                                <t-input-number
                                  v-else-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) == 'inputNumber'
                                  "
                                  class="cell_input_number cell_input_font_small"
                                  :controls="false"
                                  :precision="columnGrandSon.precision || 0"
                                  :min="0"
                                  :max="columnGrandSon.max || 999999"
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  :maxLength="6"
                                  @blur="changeCellData()"
                                  @focus="selectValue($event)"
                                  :ref="`input${scopeChildren.row.index}-${columnGrandSon.property}`"
                                  @keyup.native.enter="
                                    focusNextInput(
                                      scopeChildren.row.index,
                                      columnGrandSon.property
                                    )
                                  "
                                  :disabled="
                                    !notAcceptedFlg ||
                                    userNullFlag ||
                                    inputEnableCheck(
                                      scopeChildren.row,
                                      columnGrandSon
                                    )
                                  "
                                />

                                <!-- DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
                                <!-- 得意先担当者を表示しない -->
                                <!-- <t-select
                                  v-else-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) == 'selectCusUser'
                                  "
                                  placeholder=""
                                  class="cell_input_font_small"
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  :disabled="!notAcceptedFlg || userNullFlag"
                                >
                                  <t-option
                                    v-for="item in scopeChildren.row
                                      .managerList"
                                    :key="item.mgrCode"
                                    :label="item.mgrAbbreviation"
                                    :value="item.mgrCode"
                                  ></t-option>
                                </t-select> -->
                                <!-- DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->
                                <t-select
                                  v-else-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) == 'selectCustomer'
                                  "
                                  placeholder=""
                                  class="cell_input_font_small"
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  :disabled="!notAcceptedFlg || userNullFlag"
                                >
                                  <t-option
                                    v-for="item in customerList"
                                    :key="item.cusCode"
                                    :label="
                                      item.cusCode + ':' + item.cusAbbreviation
                                    "
                                    :value="item.cusCode"
                                  ></t-option>
                                </t-select>
                                <t-select
                                  v-else-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) == 'selectSupplier'
                                  "
                                  placeholder=""
                                  class="cell_input_font_small"
                                  clearable
                                  @change="
                                    changeSelectSupplier(
                                      scopeChildren.row,
                                      scopeChildren.column
                                    )
                                  "
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  :disabled="!notAcceptedFlg || userNullFlag"
                                >
                                  <t-option
                                    v-for="item in getSupplierList(
                                      columnGrandSon.property
                                    )"
                                    :key="item.supCode"
                                    :label="
                                      item.supCode + ':' + item.supAbbreviation
                                    "
                                    :value="item.supCode"
                                  ></t-option>
                                </t-select>

                                <!-- // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓ -->
                                <t-select
                                  v-else-if="
                                    editCellData(
                                      scopeChildren.row,
                                      columnGrandSon
                                    ) == 'selectMisumiKbn'
                                  "
                                  placeholder=""
                                  class="cell_input_font_small"
                                  @change="
                                    changeSelectMisumiKbn(
                                      scopeChildren.row,
                                      scopeChildren.column
                                    )
                                  "
                                  v-model="
                                    scopeChildren.row[columnGrandSon.property]
                                  "
                                  :disabled="
                                    isNotMisumiSupplier(scopeChildren.row) ||
                                    isMisumiSupplierAndSupplemental(
                                      scopeChildren.row
                                    ) ||
                                    !notAcceptedFlg ||
                                    userNullFlag
                                  "
                                >
                                  <t-option
                                    v-for="item in getMisumiKbnList()"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  >
                                  </t-option>

                                  <!-- ミスミ関連区分リスト以外の表示値「‐」 -->
                                  <t-option
                                    v-if="hasHiddenSelection(scopeChildren.row)"
                                    :key="
                                      getHiddenOption(scopeChildren.row).value
                                    "
                                    :label="
                                      getHiddenOption(scopeChildren.row).label
                                    "
                                    :value="
                                      getHiddenOption(scopeChildren.row).value
                                    "
                                    style="display: none"
                                  >
                                  </t-option>
                                </t-select>
                                <!-- // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑ -->
                                <span v-else>{{
                                  scopeChildren.row[columnGrandSon.property]
                                }}</span>
                              </div>
                            </div>
                            <template v-else>
                              <t-input
                                :class="columnSon.class"
                                v-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'text'
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                @blur="changeCellData()"
                                @focus="selectValue($event)"
                                :maxLength="columnSon.maxLength"
                                :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                                @keyup.native.enter="
                                  focusNextInput(
                                    scopeChildren.row.index,
                                    columnSon.prop
                                  )
                                "
                                :disabled="!notAcceptedFlg || userNullFlag"
                              />

                              <t-input
                                class="cell_input_custom cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'input'
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                @blur="changeCellData()"
                                :maxLength="columnSon.maxLength || 8"
                                :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                                @keyup.native.enter="
                                  focusNextInput(
                                    scopeChildren.row.index,
                                    columnSon.prop
                                  )
                                "
                                @focus="selectValue($event)"
                                oninput="value=value.replace(/[^\d.]/g,'').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') "
                                :disabled="!notAcceptedFlg || userNullFlag"
                              />
                              <t-input-number
                                class="cell_input_number cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'inputNumber'
                                "
                                :controls="false"
                                :precision="columnSon.precision || 0"
                                :min="0"
                                :max="columnSon.max || 999999"
                                v-model="scopeChildren.row[columnSon.prop]"
                                :maxLength="6"
                                @blur="changeCellData()"
                                @focus="selectValue($event)"
                                :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                                @keyup.native.enter="
                                  focusNextInput(
                                    scopeChildren.row.index,
                                    columnSon.prop
                                  )
                                "
                                :disabled="
                                  !notAcceptedFlg ||
                                  userNullFlag ||
                                  inputEnableCheck(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  )
                                "
                              />

                              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                              <t-input-number
                                class="cell_input_number cell_input_font_small"
                                v-else-if="
                                  scopeChildren.column.property ==
                                  'didGrossMargin'
                                "
                                :controls="false"
                                :precision="columnSon.precision || 0"
                                :min="-99.99"
                                :max="columnSon.max || 999999"
                                v-model="scopeChildren.row[columnSon.prop]"
                                :maxLength="6"
                                @blur="changeCellData()"
                                @focus="selectValue($event)"
                                :ref="`input${scopeChildren.row.index}-${columnSon.prop}`"
                                @keyup.native.enter="
                                  focusNextInput(
                                    scopeChildren.row.index,
                                    columnSon.prop
                                  )
                                "
                                :disabled="
                                  !notAcceptedFlg ||
                                  userNullFlag ||
                                  inputEnableCheck(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  )
                                "
                              />
                              <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                              <!-- DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓ -->
                              <!-- 得意先担当者を表示しない -->
                              <!-- <t-select
                                placeholder=""
                                class="cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'selectCusUser'
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                :disabled="!notAcceptedFlg || userNullFlag"
                              >
                                <t-option
                                  v-for="item in scopeChildren.row.managerList"
                                  :key="item.mgrCode"
                                  :label="item.mgrAbbreviation"
                                  :value="item.mgrCode"
                                >
                                </t-option>
                              </t-select> -->
                              <!-- DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑ -->
                              <t-select
                                placeholder=""
                                class="cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'selectCustomer'
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                :disabled="!notAcceptedFlg || userNullFlag"
                              >
                                <t-option
                                  v-for="item in customerList"
                                  :key="item.cusCode"
                                  :label="
                                    item.cusCode + ':' + item.cusAbbreviation
                                  "
                                  :value="item.cusCode"
                                >
                                </t-option>
                              </t-select>
                              <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓ -->
                              <!-- 課題_同じ通貨幣タイプ仕入先変更で、レートと加工単価が変更されない問題の改善 -->
                              <!-- <t-select
                                placeholder=""
                                class="cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'selectSupplier'
                                "
                                clearable
                                @change="
                                  changeSelectSupplier(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  )
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                :disabled="!notAcceptedFlg || userNullFlag"
                              > -->
                              <t-select
                                placeholder=""
                                class="cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'selectSupplier'
                                "
                                :clearable="supCodeClearProc(columnSon.prop)"
                                @change="
                                  changeSelectSupplier(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  )
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                :disabled="!notAcceptedFlg || userNullFlag"
                              >
                                <!-- UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑ -->

                                <t-option
                                  v-for="item in getSupplierList(
                                    columnSon.prop
                                  )"
                                  :key="item.supCode"
                                  :label="
                                    item.supCode + ':' + item.supAbbreviation
                                  "
                                  :value="item.supCode"
                                >
                                </t-option>
                              </t-select>

                              <!-- // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓ -->
                              <t-select
                                placeholder=""
                                class="cell_input_font_small"
                                v-else-if="
                                  editCellData(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  ) == 'selectMisumiKbn'
                                "
                                @change="
                                  changeSelectMisumiKbn(
                                    scopeChildren.row,
                                    scopeChildren.column
                                  )
                                "
                                v-model="scopeChildren.row[columnSon.prop]"
                                :disabled="
                                  isNotMisumiSupplier(scopeChildren.row) ||
                                  isMisumiSupplierAndSupplemental(
                                    scopeChildren.row
                                  ) ||
                                  !notAcceptedFlg ||
                                  userNullFlag
                                "
                              >
                                <t-option
                                  v-for="item in getMisumiKbnList()"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                >
                                </t-option>

                                <!-- ミスミ関連区分リスト以外の表示値「‐」 -->
                                <t-option
                                  v-if="hasHiddenSelection(scopeChildren.row)"
                                  :key="
                                    getHiddenOption(scopeChildren.row).value
                                  "
                                  :label="
                                    getHiddenOption(scopeChildren.row).label
                                  "
                                  :value="
                                    getHiddenOption(scopeChildren.row).value
                                  "
                                  style="display: none"
                                >
                                </t-option>
                              </t-select>
                              <!-- // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑ -->

                              <span v-else>
                                {{ scopeChildren.row[columnSon.prop] }}
                              </span>
                            </template>
                          </template>
                        </t-table-column>
                      </template>
                      <!-- UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑ -->
                    </t-table-column>
                  </template>
                </t-table>
              </div>
            </div>
          </t-col>
        </t-row>
      </div>

      <!-- ボタン -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="17">&nbsp;</t-col>
          <t-col :span="3" class="right">
            <!-- 一時保存 -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_150_40"
              ref="tempSaveBtn"
              :disabled="
                this.dataImportTable.length == 0 ||
                !notAcceptedFlg ||
                quoteNoExistFlg ||
                userNullFlag
              "
              @click="tempSaveClick()"
            >
              <i class="el-icon-edit-outline"></i>
              {{ $t("resource.DATA_IMPORT.TEMP_SAVE_BUTTON") }}
            </t-button></t-col
          >
          <t-col :span="4" class="right">
            <!-- 受注データ作成 -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_150_40"
              ref="confirmBtn"
              :disabled="
                this.dataImportTable.length == 0 ||
                !notAcceptedFlg ||
                quoteNoExistFlg ||
                userNullFlag
              "
              @click="addAcceptClick()"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.DATA_IMPORT.ADD_ACCEPT_BUTTON") }}
            </t-button></t-col
          >
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { ShowRemovableQuoteNoDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { outputTxt } from "@/services/common";
import {
  addAcceptInfoByDataImport,
  addDataImportDetailByDibNo,
  editDataImportDetailByDibNo,
  getCusCodeForUserInfo,
  initDataImportDetailCusUserList,
  initDataImportDetailList,
  searchDataImportDetailByDibNo,
} from "@/services/dataImport";
import {
  cmpDetailData,
  formatCurrencyToNumber,
  formatDateStrToString,
  formatDateStrToyyyyMMdd,
  formatDateToShortYear,
  formatDateToString,
  formatStringToCurrency,
  formatStringToWeight,
  formatSystemTimeToyyyyMMddHHmmss,
  getAbleUserInfoList,
  getEditColWidthArr,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  DIB_ACCEPT_ORDER_WAITING,
  FACTORY_KBN_DALIAN,
  NUM_ONE,
  NUM_ZERO,
  STR_BACKSLASH,
  STR_DALIAN,
  STR_DIB_ACCEPT_ORDER_END,
  STR_DIB_ACCEPT_ORDER_WAITING,
  STR_EMPTY,
  STR_HYPHEN,
  STR_ONE,
  STR_SUPPLEMENTAL,
  STR_UNDERLINE,
  STR_ZERO,
  UNIT_SET,
} from "@/utils/const";
import config from "@/validation/importCheck.json";
import { Message, Modal } from "@tellus/component";
import * as XLSX from "xlsx";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},
      //読み込み回数
      numLoads: 1,

      //取込No.
      dataImportNo: STR_EMPTY,

      dataImportEditForm: {
        dibUserCode: STR_EMPTY,
        dibImportTime: STR_EMPTY,
        dibFileName: STR_EMPTY,
        dibAcceptState: STR_EMPTY,
      },

      // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
      //基本情報のheight
      // basicHeight: DIALOG_LINE_HEIGHT * 2,
      //明細情報のheight
      // detailHeight: getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 3,
      //   DIALOG_LINE_HEIGHT * 1,
      //   30
      // ),

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 2 + 49,
      //明細情報のheight
      detailHeight:
        window.innerHeight * 0.99 -
        65 -
        (49 + 45 + 45) -
        DIALOG_LINE_HEIGHT * 2 -
        35,

      activeNames: ["dataImportBasic"],
      // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
      //ボタンのheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      //テーブル
      dataImportTable: [],

      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      // 列固定の変更：「数量/タイプ」列
      // 複数の表見出しで列を固定できません
      leftColumns: [
        {
          prop: "didQuoteNo",
          label: t("resource.DATA_IMPORT.QUOTE_NO"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TEN"),
          class: "cell_txt_left input_font_small",
          fixed: true,
          overflowTooltip: true,
        },

        // 受注日 / 納期
        {
          prop: "didDateShow",
          label:
            t("resource.DATA_IMPORT.ACCEPT_DATE") +
            STR_BACKSLASH +
            t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"),
          width: t("widgetSize.COMMON_WIDTH.NINETY"),
          fixed: true,
          class: "combined-cell cell_txt_center input_font_small",
          grandChildren: [
            {
              property: "didAcceptDateShow",
              label: t("resource.DATA_IMPORT.ACCEPT_DATE"),
            },
            {
              property: "didCusDeliveryDateShow",
              label: t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"),
            },
          ],
          overflowTooltip: true,
        },

        // 図番/品名
        {
          prop: "didDrawNoProdName",
          label:
            t("resource.DATA_IMPORT.PROD_DRAW_NO") +
            STR_BACKSLASH +
            t("resource.DATA_IMPORT.PROD_NAME"),
          width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
          class: "combined-cell cell_txt_left input_font_small",
          grandChildren: [
            {
              property: "didProdDrawNo",
              label: t("resource.DATA_IMPORT.PROD_DRAW_NO"),
            },
            {
              property: "didProdName",
              label: t("resource.DATA_IMPORT.PROD_NAME"),
            },
          ],
          overflowTooltip: true,
        },
        // 数量(単位) / タイプ
        {
          prop: "didProdQtyType",
          class: "input_font_small cell_txt_right",
          label:
            t("resource.DATA_IMPORT.PROD_QUANTITY") +
            STR_BACKSLASH +
            t("resource.DATA_IMPORT.TYPE"),
          width: t("widgetSize.tableCommon.width90"),
          fixed: true,
          grandChildren: [
            {
              property: "didProdQtyUnit",
              label: t("resource.DATA_IMPORT.PROD_QUANTITY"),
            },
            {
              property: "didType",
              label: t("resource.DATA_IMPORT.TYPE"),
            },
          ],
        },
        // 形状の追加
        {
          prop: "didProdShape",
          label: t("resource.DATA_IMPORT.PROD_SHAPE"),
          width: t("widgetSize.tableCommon.width80"),
          class: "cell_txt_left input_font_small",
          overflowTooltip: true,
        },
      ],
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      //テーブルの列
      columns: [
        // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        // {
        //   label: t("resource.DATA_IMPORT.BASIC_INFO"),
        //   children: [
        //     {
        //       prop: "didQuoteNo",
        //       label: t("resource.DATA_IMPORT.QUOTE_NO"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //       class: "cell_txt_left",
        //       fixed: true,
        //     },
        // 見積情報の後ろに移動します
        // {
        //   prop: "didCusCode",
        //   label: t("resource.DATA_IMPORT.CUS_CODE"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
        //   class: "cell_txt_left",
        //   fixed: true,
        // },
        // {
        //   prop: "didCusUserCode",
        //   label: t("resource.DATA_IMPORT.CUS_USER_CODE"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
        //   class: "cell_txt_left",
        //   fixed: true,
        // },
        // {
        //   prop: "didAcceptDate",
        //   label: t("resource.DATA_IMPORT.ACCEPT_DATE"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
        //   class: "cell_txt_center",
        //   fixed: true,
        // },
        // {
        //   prop: "didCusDeliveryDate",
        //   label: t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
        //   class: "cell_txt_center",
        //   fixed: true,
        // },
        // {
        //   prop: "didCusOrderNo",
        //   label: t("resource.DATA_IMPORT.CUS_ORDER_NO"),
        //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //   class: "cell_txt_left",
        //   fixed: true,
        //   overflowTooltip: true,
        //   maxLength: 20,
        // },
        //   ],
        // },
        // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

        // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 列固定の変更：「数量/タイプ」列
        // {
        //   label: t("resource.DATA_IMPORT.PRODUCT_INFO"),
        //   children: [
        //     // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        //     {
        //       prop: "didQuoteNo",
        //       label: t("resource.DATA_IMPORT.QUOTE_NO"),
        //       // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        //       // 課題_画面と文字サイズの調整
        //       // width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TEN"),
        //       // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        //       class: "cell_txt_left input_font_small",
        //       fixed: true,
        //       overflowTooltip: true,
        //     },

        //     // 受注日 / 納期
        //     {
        //       prop: "didDateShow",
        //       label:
        //         t("resource.DATA_IMPORT.ACCEPT_DATE") +
        //         STR_BACKSLASH +
        //         t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"),
        //       width: t("widgetSize.COMMON_WIDTH.NINETY"),
        //       fixed: true,
        //       class: "combined-cell cell_txt_center input_font_small",
        //       grandChildren: [
        //         {
        //           property: "didAcceptDateShow",
        //           label: t("resource.DATA_IMPORT.ACCEPT_DATE"),
        //         },
        //         {
        //           property: "didCusDeliveryDateShow",
        //           label: t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"),
        //         },
        //       ],
        //       overflowTooltip: true,
        //     },
        //     // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

        //     // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        //     // {
        //     //   label: t("resource.DATA_IMPORT.TYPE"),
        //     //   prop: "didType",
        //     //   width: t("widgetSize.tableCommon.width80"),
        //     //   class: "cell_txt_center",
        //     //   overflowTooltip: true,
        //     //   fixed: true,
        //     // },
        //     // {
        //     //   prop: "didProdDrawNo",
        //     //   label: t("resource.DATA_IMPORT.PROD_DRAW_NO"),
        //     //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //     //   class: "cell_txt_left",
        //     //   overflowTooltip: true,
        //     // },
        //     // {
        //     //   prop: "didProdName",
        //     //   label: t("resource.DATA_IMPORT.PROD_NAME"),
        //     //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
        //     //   class: "cell_txt_left",
        //     //   overflowTooltip: true,
        //     // },
        //     //  {
        //     //   prop: "didProdQuantity",
        //     //   label: t("resource.DATA_IMPORT.PROD_QUANTITY"),
        //     //   width: t("widgetSize.tableCommon.width80"),
        //     //   class: "cell_txt_right",
        //     // },
        //     // {
        //     //   prop: "didProdUnit",
        //     //   label: t("resource.DATA_IMPORT.PROD_UNIT"),
        //     //   width: t("widgetSize.tableCommon.width80"),
        //     //   class: "cell_txt_center",
        //     //   overflowTooltip: true,
        //     // },

        //     // 図番/品名
        //     {
        //       prop: "didDrawNoProdName",
        //       label:
        //         t("resource.DATA_IMPORT.PROD_DRAW_NO") +
        //         STR_BACKSLASH +
        //         t("resource.DATA_IMPORT.PROD_NAME"),
        //       width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
        //       class: "combined-cell cell_txt_left input_font_small",
        //       grandChildren: [
        //         {
        //           property: "didProdDrawNo",
        //           label: t("resource.DATA_IMPORT.PROD_DRAW_NO"),
        //         },
        //         {
        //           property: "didProdName",
        //           label: t("resource.DATA_IMPORT.PROD_NAME"),
        //         },
        //       ],
        //       overflowTooltip: true,
        //     },
        //     // 数量(単位) / タイプ
        //     {
        //       prop: "didProdQtyType",
        //       class: "input_font_small cell_txt_right",
        //       label:
        //         t("resource.DATA_IMPORT.PROD_QUANTITY") +
        //         STR_BACKSLASH +
        //         t("resource.DATA_IMPORT.TYPE"),
        //       width: t("widgetSize.tableCommon.width90"),
        //       fixed: true,
        //       grandChildren: [
        //         {
        //           property: "didProdQtyUnit",
        //           label: t("resource.DATA_IMPORT.PROD_QUANTITY"),
        //         },
        //         {
        //           property: "didType",
        //           label: t("resource.DATA_IMPORT.TYPE"),
        //         },
        //       ],
        //     },
        //     // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

        //     // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        //     // 形状の追加
        //     {
        //       prop: "didProdShape",
        //       label: t("resource.DATA_IMPORT.PROD_SHAPE"),
        //       width: t("widgetSize.tableCommon.width80"),
        //       class: "cell_txt_left input_font_small",
        //       overflowTooltip: true,
        //     },

        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
        /* {
              prop: "didProdShape",
              label: t("resource.DATA_IMPORT.PROD_SHAPE"),
              width: t("widgetSize.tableCommon.width80"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "didProdMaterial",
              label: t("resource.DATA_IMPORT.PROD_MATERIAL"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            },
            {
              prop: "didProdTreatment",
              label: t("resource.DATA_IMPORT.PROD_TREATMENT"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left",
              overflowTooltip: true,
            }, */

        // 重量を加工単価と運賃の間に入れる
        /* {
              prop: "didUWeight",
              label: t("resource.DATA_IMPORT.U_WEIGHT"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              precision: 3,
              max: 999.999,
              class: "cell_txt_right",
            }, */
        // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
        //   ],
        // },
        // DEL 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

        {
          label: t("resource.DATA_IMPORT.MAIN_PROCESSING"),
          children: [
            {
              prop: "didMSupCode",
              label: t("resource.DATA_IMPORT.SUPPLIER"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              // class: "cell_txt_left",
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              overflowTooltip: true,
            },

            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
            // ミスミ関連区分
            {
              prop: "didMisumiKbn",
              label: t("resource.DATA_IMPORT.MSM_KBN"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              class: "cell_txt_left input_font_small",
              overflowTooltip: true,
            },
            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

            // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
            // {
            //   prop: "didMSupFactoryKbnStr",
            //   label: t("resource.DATA_IMPORT.SUP_FACTORY_KBN"),
            //   width: t("widgetSize.tableCommon.width80"),
            //   class: "cell_txt_left",
            // },
            // {
            //   prop: "didMCurType",
            //   label: t("resource.DATA_IMPORT.EXR_CUR_TYPE"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_left",
            // },
            // {
            //   prop: "didMUPriceCny",
            //   label: t("resource.DATA_IMPORT.U_PRICE_CNY"),
            //   maxLength: 7,
            //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
            //   class: "cell_txt_right",
            // },
            // {
            //   prop: "didMUPriceJpy",
            //   label: t("resource.DATA_IMPORT.U_PRICE_JPY"),
            //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
            //   class: "cell_txt_right",
            //   overflowTooltip: true,
            // },
            // {
            //   prop: "didMUTransportCostCny",
            //   label: t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY"),
            //   width: t("widgetSize.tableCommon.defaultWidth"),
            //   class: "cell_txt_right",
            //   maxLength: 7,
            //   precision: 2,
            //   max: 99999.99,
            // },

            // 工場 (貨幣) / レート
            {
              prop: "didSupFacKbnExr",
              class: "input_font_small cell_txt_left",
              label:
                t("resource.DATA_IMPORT.SUP_FACTORY_KBN") +
                STR_BACKSLASH +
                t("resource.DATA_IMPORT.EXCHANGE_RATE"),
              width: t("widgetSize.tableCommon.width90"),
              fixed: true,
              grandChildren: [
                {
                  property: "didSupFacKbnCurType",
                  label: t("resource.DATA_IMPORT.SUP_FACTORY_KBN"),
                },
                {
                  property: "didMExr",
                  label: t("resource.DATA_IMPORT.EXCHANGE_RATE"),
                  max: 999.99,
                  precision: 2,
                },
              ],
            },
            {
              prop: "didMUPrice",
              class: "input_font_small cell_txt_right",
              label:
                t("resource.DATA_IMPORT.U_PRICE") +
                "(CNY" +
                STR_BACKSLASH +
                "JPY)",
              width: t("widgetSize.tableCommon.width130"),
              overflowTooltip: true,
              grandChildren: [
                {
                  property: "didMUPriceCny",
                  label: t("resource.DATA_IMPORT.U_PRICE_CNY"),
                  // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
                  // 加工単価(CNY)の入力可能な最大値の変更
                  //maxLength: 7,
                  maxLength: 10,
                  // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
                },
                {
                  property: "didMUPriceJpy",
                  label: t("resource.DATA_IMPORT.U_PRICE_JPY"),
                  // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
                  // 加工単価(CNY)の入力可能な最大値の変更
                  maxLength: 10,
                  // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
                },
              ],
            },
            {
              prop: "didUWeightTransCost",
              class: "input_font_small cell_txt_right",
              label:
                t("resource.DATA_IMPORT.U_WEIGHT") +
                STR_BACKSLASH +
                t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY"),
              width: t("widgetSize.tableCommon.width120"),
              overflowTooltip: true,
              grandChildren: [
                {
                  property: "didUWeight",
                  label: t("resource.DATA_IMPORT.U_WEIGHT"),
                  precision: 3,
                  max: 999.999,
                },
                {
                  property: "didMUTransportCostCny",
                  label: t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY"),
                  // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
                  // 加工単価(CNY)の入力可能な最大値の変更
                  // maxLength: 7,
                  // precision: 2,
                  // max: 99999.99,
                  maxLength: 9,
                  precision: 2,
                  // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
                },
              ],
            },

            // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
            {
              prop: "didMCommissionRate",
              label: t("resource.DATA_IMPORT.COMMISSION_RATE"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.tableCommon.defaultWidth"),
              // class: "cell_txt_right",
              width: t("widgetSize.tableCommon.width80"),
              class: "cell_txt_right input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              maxLength: 5,
              precision: 2,
              max: 99.99,
            },
            // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
            // {
            //   prop: "didMUPurchasePriceCny",
            //   label: t("resource.DATA_IMPORT.U_PURCHASE_PRICE_CNY"),
            //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
            //   class: "cell_txt_right",
            //   overflowTooltip: true,
            // },
            // {
            //   prop: "didMUPurchasePriceJpy",
            //   label: t("resource.DATA_IMPORT.U_PURCHASE_PRICE_JPY"),
            //   width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
            //   class: "cell_txt_right",
            //   overflowTooltip: true,
            // },

            // 仕入価格(CNY/JPY)

            {
              prop: "didMUPurPriceCnyJPY",
              class: "input_font_small cell_txt_right",
              label:
                t("resource.DATA_IMPORT.U_PURCHASE_PRICE") +
                "(CNY" +
                STR_BACKSLASH +
                "JPY)",
              width: t("widgetSize.tableCommon.width110"),
              overflowTooltip: true,
              grandChildren: [
                {
                  property: "didMUPurchasePriceCny",
                  label: t("resource.DATA_IMPORT.U_PURCHASE_PRICE_CNY"),
                },
                {
                  property: "didMUPurchasePriceJpy",
                  label: t("resource.DATA_IMPORT.U_PURCHASE_PRICE_JPY"),
                },
              ],
            },
            // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
          ],
        },
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        // 処理1.処理2.処理3を見積情報の後ろに移動します
        {
          label: t("resource.DATA_IMPORT.QUOTE_INFO"),
          children: [
            {
              prop: "didGrossMargin",
              label: t("resource.DATA_IMPORT.GROSS_MARGIN"),
              width: t("widgetSize.tableCommon.width80"),
              class: "cell_txt_right input_font_small",
              precision: 2,
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // max: 99.99,
              max: 100,
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            },
            {
              prop: "didUSalesPriceSetPrice",
              class: "input_font_small cell_txt_right",
              label:
                // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // t("resource.DATA_IMPORT.U_SALES_PRICE") +
                // STR_BACKSLASH +
                // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                t("resource.DATA_IMPORT.U_SET_PRICE"),
              width: t("widgetSize.tableCommon.width110"),
              overflowTooltip: true,
              grandChildren: [
                // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // 売価が非表示の変更
                // {
                //   property: "didUSalesPrice",
                //   label: t("resource.DATA_IMPORT.U_SALES_PRICE"),
                // },
                // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                {
                  property: "didUSetPrice",
                  label: t("resource.DATA_IMPORT.U_SET_PRICE"),
                  // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
                  // 加工単価(CNY)の入力可能な最大値の変更
                  maxLength: 15,
                  // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
                },
              ],
            },
          ],
        },
        // 得意先情報
        {
          label: t("resource.DATA_IMPORT.CUSTOMER_INFO"),
          children: [
            {
              prop: "didCusCodeUserCode",
              class: "input_font_small cell_txt_left",
              // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
              // label:
              //   t("resource.DATA_IMPORT.CUS_CODE") +
              //   STR_BACKSLASH +
              //   t("resource.DATA_IMPORT.CUS_USER_CODE"),
              label: t("resource.DATA_IMPORT.CUS_CODE"),
              // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
              width: t("widgetSize.tableCommon.width150"),
              overflowTooltip: true,
              grandChildren: [
                {
                  property: "didCusCode",
                  label: t("resource.DATA_IMPORT.CUS_CODE"),
                },
                // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
                // {
                //   property: "didCusUserCode",
                //   label: t("resource.DATA_IMPORT.CUS_USER_CODE"),
                // },
                // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
              ],
            },

            {
              prop: "didCusOrderNo",
              label: t("resource.DATA_IMPORT.CUS_ORDER_NO"),
              // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
              // width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
              class: "cell_txt_left input_font_small cell_input_font_small",
              fixed: true,
              overflowTooltip: true,
              // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 start↓
              // 品名、注番文字数：「20」⇒「50」
              // maxLength: 20,
              maxLength: 50,
              // UPD 2025/12/08 ZLL 課題_251208顧客からの改善したい点への対応 end↑
            },
          ],
        },
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
        {
          label: t("resource.DATA_IMPORT.PROCESSING_ONE"),
          children: [
            {
              prop: "didP1SupCode",
              label: t("resource.DATA_IMPORT.SUPPLIER"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              // class: "cell_txt_left",
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
              // 加工単価(CNY)の入力可能な最大値の変更
              maxLength: 10,
              // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
              overflowTooltip: true,
            },
            {
              prop: "didP1SupFactoryKbnStr",
              label: t("resource.DATA_IMPORT.SUP_FACTORY_KBN"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.tableCommon.width80"),
              // class: "cell_txt_left",
              width: t("widgetSize.tableCommon.width60"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
            },
            {
              prop: "didP1UPrice",
              label: t("resource.DATA_IMPORT.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // class: "cell_txt_right",
              class: "cell_txt_right input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
              // 加工単価(CNY)の入力可能な最大値の変更
              maxLength: 10,
              // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
              overflowTooltip: true,
            },
          ],
        },
        {
          label: t("resource.DATA_IMPORT.PROCESSING_TWO"),
          children: [
            {
              prop: "didP2SupCode",
              label: t("resource.DATA_IMPORT.SUPPLIER"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              // class: "cell_txt_left",
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              overflowTooltip: true,
            },
            {
              prop: "didP2SupFactoryKbnStr",
              label: t("resource.DATA_IMPORT.SUP_FACTORY_KBN"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.tableCommon.width80"),
              // class: "cell_txt_left",
              width: t("widgetSize.tableCommon.width60"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
            },
            {
              prop: "didP2UPrice",
              label: t("resource.DATA_IMPORT.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // class: "cell_txt_right",
              class: "cell_txt_right input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
              // 加工単価(CNY)の入力可能な最大値の変更
              maxLength: 10,
              // ADD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
              overflowTooltip: true,
            },
          ],
        },
        {
          label: t("resource.DATA_IMPORT.PROCESSING_THREE"),
          children: [
            {
              prop: "didP3SupCode",
              label: t("resource.DATA_IMPORT.SUPPLIER"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_EIGHTY"),
              // class: "cell_txt_left",
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_FIFTY"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              overflowTooltip: true,
            },
            {
              prop: "didP3SupFactoryKbnStr",
              label: t("resource.DATA_IMPORT.SUP_FACTORY_KBN"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // width: t("widgetSize.tableCommon.width80"),
              // class: "cell_txt_left",
              width: t("widgetSize.tableCommon.width60"),
              class: "cell_txt_left input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
            },
            {
              prop: "didP3UPrice",
              label: t("resource.DATA_IMPORT.U_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
              // class: "cell_txt_right",
              class: "cell_txt_right input_font_small",
              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
              overflowTooltip: true,
            },
          ],
        },

        // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        // 処理1.処理2.処理3を見積情報の後ろに移動します
        /* {
          label: t("resource.DATA_IMPORT.QUOTE_INFO"),
          children: [
            {
              prop: "didGrossMargin",
              label: t("resource.DATA_IMPORT.GROSS_MARGIN"),
              width: t("widgetSize.tableCommon.defaultWidth"),
              class: "cell_txt_right",
              precision: 2,
              max: 99.99,
            },
            {
              prop: "didUSalesPrice",
              label: t("resource.DATA_IMPORT.U_SALES_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
            {
              prop: "didUSetPrice",
              label: t("resource.DATA_IMPORT.U_SET_PRICE"),
              width: t("widgetSize.COMMON_WIDTH.ONE_HUNDRED_AND_TWENTY"),
              class: "cell_txt_right",
              overflowTooltip: true,
            },
          ],
        }, */
        // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
      ],

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 3),

      //受注状態
      statusList: [],
      //担当者
      userList: [],
      //タイプ
      typeList: [],
      //得意先
      customerList: [],
      //仕入先
      supplierList: [],
      //工場
      supKbnList: [],

      // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓
      // 「共通設定」の提成率(%)
      commissionRate: 0,
      // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑

      // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
      // //得意先コードリスト(取込担当者コードで)
      // cusCodeByDibUserCodeList: [],
      // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
      //CNYToJPYのレート
      //exrRateCNY: 1,

      //データの更新時刻
      didUpdateTime: null,

      //新規フラグ　true:新規
      localIsAdd: this.isAdd,

      //再度取込フラグ true:再度取込
      dataImportAgainFlag: false,

      //カバー層のフラップ false:表示しない
      showFlag: false,

      //受注待ちフラグ[受注データ取込、一時保存、受注データ作成] true:編集可能 false:編集不可
      notAcceptedFlg: true,

      //取込見積No存在フラグ  true:存在、編集不可
      quoteNoExistFlg: false,

      //受注済みフラグ[削除] true:編集不可 false:編集可能
      acceptedFlg: false,

      //取込担当者フラグ true:空、クリック不可　 false:非空、クリック可
      userNullFlag: false,

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 注番の列幅フラグ（true:増加）
      didCusOrderNoChangeWidth: false,
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
      // ミスミ関連区分リスト
      misumiKbnList: [],
      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    rowData: {
      Type: Object,
    },
  },

  computed: {
    getSupplierList() {
      return (prop) => {
        if (prop != "didMSupCode") {
          return this.supplierList.filter((item) => item.supFactoryKbn !== "1");
        } else {
          return this.supplierList;
        }
      };
    },
  },

  watch: {
    "dataImportEditForm.dibAcceptState"(value) {
      //受注待ち
      var acceptStateWaiting = this.statusList.find(
        (it) => it.label === STR_DIB_ACCEPT_ORDER_WAITING
      )?.value;

      //受注状態が受注待ち以外の場合、「受注データ取込、一時保存、受注データ作成」ボタンが使用不可、受注待ちフラグをfalseに変更する
      if (!this.isEmptyOrNull(value) && value != acceptStateWaiting) {
        this.notAcceptedFlg = false;
      } else {
        this.notAcceptedFlg = true;
      }

      //受注済み
      var acceptStateEnd = this.statusList.find(
        (it) => it.label === STR_DIB_ACCEPT_ORDER_END
      )?.value;

      //受注状態が受注済みの場合、「削除」ボタンが使用不可、受注済みフラグをtrueに変更する
      if (!this.isEmptyOrNull(value) && value == acceptStateEnd) {
        this.acceptedFlg = true;
      } else {
        this.acceptedFlg = false;
      }
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 注番の列幅フラグ（true:増加）
    didCusOrderNoChangeWidth() {
      this.columns = this.columns.map((col) => {
        if (col.children) {
          col.children = col.children.map((child) => {
            //注番
            if (child.prop === "didCusOrderNo") {
              return {
                ...child,
                width: this.didCusOrderNoChangeWidth ? 210 : 120,
              };
            }
            return child;
          });
        }
        return col;
      });
    },
    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
  },

  mounted() {
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
    //折り畳みパネルの処理
    handleCollapseChange() {
      this.handleResize();
    },
    // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

    // 初期化
    init() {
      this.showFlag = true;
      //リストの初期化
      this.infoInit();

      this.handleResize();
    },

    //リストの取得
    infoInit() {
      //リストの初期化（取込担当者、タイプ、受注状態、得意先、仕入先、工場）
      initDataImportDetailList()
        .then((res) => {
          this.$nextTick(() => {
            //取込担当者
            this.userList = [];
            res.userList.forEach((item) => {
              this.userList.push({
                UserName: item.UserName,
                UserId: item.UserId,
                Contraction: item.Contraction,
                DeleteFlg: item.DeleteFlg,
              });
            });
            //使用可能な取込担当者リストの取得
            //this.getAbleList();

            //タイプ
            this.typeList = res.typeList;
            //受注状態
            this.statusList = res.statusList;
            //得意先
            this.customerList = res.customerList;
            //仕入先
            this.supplierList = res.supplierList;
            //工場
            this.supKbnList = res.supKbnList;
            //CNYToJPYのレート
            //this.exrRateCNY = res.exrRateCNY;

            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
            // ミスミ関連区分リストの取得
            this.misumiKbnList = res.misumiKbnList;
            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

            // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓
            // 「共通設定」の提成率(%)を取得
            this.commissionRate = res.commissionRate;
            // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑

            //取込担当者が空の場合、ボタンがクリック不可
            if (
              this.userList.find((it) => it.UserId === getUserInfo().UserId) ==
              undefined
            ) {
              this.userNullFlag = true;
              this.showFlag = false;
              return;
            }

            //初期値の設定
            this.setInitValue(this.rowData);
          });
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        });
    },

    //使用可能な取込担当者リストの取得
    getAbleList() {
      // 取込担当者リスト
      this.userList = getAbleUserInfoList(
        this.userList,
        this.dataImportEditForm.dibUserCode
      );
    },

    //初期値の設定
    setInitValue(data) {
      //新規の場合
      if (this.localIsAdd) {
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        // 基本情報の展開を表示
        this.activeNames = ["dataImportBasic"];
        this.handleCollapseChange(this.activeNames);
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

        //取込担当者
        this.dataImportEditForm.dibUserCode = getUserInfo().UserId;
        //ログインユーザの省略字が空の場合、取込担当者が空を変更する
        if (
          !this.userList.some(
            (user) => user.UserId == this.dataImportEditForm.dibUserCode
          )
        ) {
          this.dataImportEditForm.dibUserCode = "";
        }

        //取込時間
        this.dataImportEditForm.dibImportTime = STR_EMPTY;
        //ファイル名
        this.dataImportEditForm.dibFileName = STR_EMPTY;
        //受注状態
        this.dataImportEditForm.dibAcceptState = STR_EMPTY;

        this.showFlag = false;
      } else {
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        //　基本情報の折畳み式を表示
        this.activeNames = [""];
        this.handleCollapseChange(this.activeNames);
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
        //編集の場合
        this.dataImportNo = data.dibNo;

        //取込担当者
        // this.dataImportEditForm.dibUserCode = this.userList.find(
        //   (it) => it.UserName === data.dibUserCode
        // )?.UserId;

        //取込担当者の省略字が空の場合、データが編集不可
        if (this.userList.some((user) => user.UserName == data.dibUserCode)) {
          this.dataImportEditForm.dibUserCode = this.userList.find(
            (it) => it.UserName === data.dibUserCode
          )?.UserId;
        } else {
          this.dataImportEditForm.dibUserCode = data.dibUserCode;
          this.userNullFlag = true;
        }

        //取込時間
        this.dataImportEditForm.dibImportTime = data.dibImportTime;

        //ファイル名
        this.dataImportEditForm.dibFileName = data.dibFileName;
        //受注状態
        this.dataImportEditForm.dibAcceptState = this.statusList.find(
          (it) => it.label === data.dibAcceptState
        )?.value;

        //受注待ちフラグ true:編集可能 false:編集不可
        this.notAcceptedFlg =
          this.dataImportEditForm.dibAcceptState == DIB_ACCEPT_ORDER_WAITING
            ? true
            : false;

        //検索
        this.searchDataImportDetailByDibNoProc();
      }
    },

    //検索
    searchDataImportDetailByDibNoProc() {
      //取込No.による受注データ詳細情報の取得
      searchDataImportDetailByDibNo({
        didNo: this.dataImportNo,
        dibUserCode: this.dataImportEditForm.dibUserCode,
      })
        .then((res) => {
          this.dataImportEditForm.dibAcceptState =
            res.dataImportBasicInfo.acceptState;

          this.didUpdateTime = res.didUpdateTime;
          this.dataImportTable = res.dataImportDetailInfos;

          // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
          //this.cusCodeByDibUserCodeList = res.cusCodeByDibUserCodeList;
          // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
          // 注番の列幅フラグ（true:増加）
          this.didCusOrderNoChangeWidth = false;
          // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    //テーブルの高さを設定する
    handleResize() {
      // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
      // this.detailHeight = getDialogContentHeight(
      //   window.innerHeight,
      //   DIALOG_LINE_HEIGHT * 3,
      //   DIALOG_LINE_HEIGHT * 1,
      //   30
      // );

      var val = this.activeNames;
      if (val.indexOf("dataImportBasic") !== -1) {
        this.basicHeight = DIALOG_LINE_HEIGHT * 2 + 49;
        this.detailHeight =
          window.innerHeight * 0.99 -
          65 -
          (49 + 45 + 45) -
          DIALOG_LINE_HEIGHT * 2 -
          35;
      } else {
        this.basicHeight = DIALOG_LINE_HEIGHT;
        this.detailHeight =
          window.innerHeight * 0.99 -
          65 -
          DIALOG_LINE_HEIGHT -
          DIALOG_LINE_HEIGHT * 2 -
          35;
      }
      this.colArr = getEditColWidthArr(window.innerWidth, 3);
      // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
    },

    //データの処理
    dataProcess() {
      this.dataImportTable.map((item) => {
        // 受注日
        item.didAcceptDate = formatDateStrToString(item.didAcceptDate);

        // 納期
        item.didCusDeliveryDate = formatDateStrToString(
          item.didCusDeliveryDate
        );

        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 注番
        if (item.didCusOrderNo.length > 10) {
          //注番の列幅フラグ（true:増加）
          this.didCusOrderNoChangeWidth = true;
        }
        // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
        //ミスミ仕入先以外またはミスミ仕入先&&金額調整の場合、ミスミ関連区分が「‐」を表示する
        if (
          this.isNotMisumiSupplier(item) ||
          this.isMisumiSupplierAndSupplemental(item)
        ) {
          item.didMisumiKbn = STR_ZERO;
        } else {
          item.didMisumiKbn = item.didMisumiKbn;
        }
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

        //加工_工場
        item.didMSupFactoryKbnStr = this.supKbnList.find(
          (it) => it.value === item.didMSupFactoryKbn
        )?.label;
        if (item.didMCurType == STR_EMPTY) {
          item.didMCurType =
            item.didMSupFactoryKbnStr == STR_DALIAN ? "CNY" : "JPY";
        }

        // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓
        // 提成率(%)の空のチェック
        if (
          this.checkIsNull(item.didMCommissionRate) ||
          parseFloat(item.didMCommissionRate) == NUM_ZERO
        ) {
          item.didMCommissionRate = 0.0;
        }

        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 粗利率(%)計算と入力の変更:粗利率％ = [1-(仕入価格(JPY)/確定売価]×100
        // // 粗利率(%)の空のチェック
        // if (
        //   this.checkIsNull(item.didGrossMargin) ||
        //   parseFloat(item.didGrossMargin) == NUM_ZERO
        // ) {
        //   item.didGrossMargin = 0.0;
        // }
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑

        //大連工場の場合、人民元に準じる
        if (item.didMSupFactoryKbnStr == STR_DALIAN) {
          //加工_レート
          item.didMExr = this.isEmptyOrNull(item.didMExr) //|| item.didMExr == 1
            ? //? this.exrRateCNY
              0
            : item.didMExr;

          // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
          // 加工単価(CNY)の入力可能な最大値の変更

          // //加工_加工単価(CNY):入力最大値：99999.99
          // if (formatCurrencyToNumber(item.didMUPriceCny) > 99999.99) {
          //   item.didMUPriceCny = 99999.99;
          // }

          //加工_加工単価(CNY):入力最大値：99999.99⇒9999999.99
          if (formatCurrencyToNumber(item.didMUPriceCny) > 9999999.99) {
            item.didMUPriceCny = 9999999.99;
          } // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑
          item.didMUPriceCny = formatStringToWeight(item.didMUPriceCny);

          //加工_加工単価(JPY)
          item.didMUPriceJpy = formatStringToCurrency(
            formatCurrencyToNumber(item.didMUPriceCny) * item.didMExr
          );

          // UPD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓
          // if (item.didType == t("resource.DATA_IMPORT.PRODUCT")) {
          //   //運賃
          //   item.didMUTransportCostCny = formatStringToWeight(
          //     this.calDidMUTransportCostCny(
          //       formatCurrencyToNumber(item.didMUPriceCny),
          //       item.didUWeight
          //     )
          //   );
          // }

          // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 start↓
          // 加工単価(CNY)の入力可能な最大値の変更
          // 運賃:入力最大値：99999.99
          // if (formatCurrencyToNumber(item.didMUTransportCostCny) > 99999.99) {
          //   item.didMUTransportCostCny = 99999.99;
          // }
          //運賃:入力最大値：99999.99⇒9999999.99
          if (formatCurrencyToNumber(item.didMUTransportCostCny) > 9999999.99) {
            item.didMUTransportCostCny = 9999999.99;
          }
          // UPD 2026/04/01 Wjx 課題_顧客からの改善したい点への対応 end↑

          // 運賃(CNY)
          item.didMUTransportCostCny = formatStringToWeight(
            item.didMUTransportCostCny
          );
          // UPD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑

          //仕入価格(CNY)=加工_加工単価(CNY) + 加工_運賃(CNY/个) + 加工_加工単価(CNY) * 加工_提成率（%）
          item.didMUPurchasePriceCny = formatStringToWeight(
            formatCurrencyToNumber(item.didMUPriceCny) +
              formatCurrencyToNumber(item.didMUTransportCostCny) +
              formatCurrencyToNumber(item.didMUPriceCny) *
                formatCurrencyToNumber(item.didMCommissionRate) *
                0.01
          );
          //仕入価格(JPY)=仕入価格(CNY)*レート
          item.didMUPurchasePriceJpy = formatStringToCurrency(
            formatCurrencyToNumber(item.didMUPurchasePriceCny) * item.didMExr
          );
        } else {
          //大連工場以外の場合、円に準じる
          item.didMUPriceJpy = formatStringToCurrency(item.didMUPriceJpy);
          //加工_レート
          item.didMExr = 1;
          item.didMUPriceCny = 0;
          item.didMUTransportCostCny = 0;
          item.didMCommissionRate = 0;
          item.didMUPurchasePriceCny = 0;
          //仕入価格(JPY)=加工単価(JPY)
          item.didMUPurchasePriceJpy = formatStringToCurrency(
            formatCurrencyToNumber(item.didMUPriceJpy)
          );
          //仕入価格(CNY)=0
          item.didMUPurchasePriceCny = 0;
        }

        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 粗利率％ = [1-(仕入価格(JPY)/確定売価]×100
        //確定売価が０の場合、粗利率が０を表示する
        if (item.didUSetPrice == 0) {
          item.didGrossMargin = 0;
        } else {
          let grossMargin =
            (1 -
              (formatCurrencyToNumber(item.didMUPurchasePriceJpy) +
                formatCurrencyToNumber(item.didP1UPrice) +
                formatCurrencyToNumber(item.didP2UPrice) +
                formatCurrencyToNumber(item.didP3UPrice)) /
                formatCurrencyToNumber(item.didUSetPrice)) *
            100;

          // 粗利率が-99.99以下の場合、「-99.99」」を表示する
          grossMargin = Math.max(-99.99, grossMargin);
          // 粗利率が100以上の場合、「100.00」を表示する
          grossMargin = Math.min(100, grossMargin);

          item.didGrossMargin = parseFloat(grossMargin.toFixed(2)); // 保留2位小数
        }
        // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

        //処理1_工場
        item.didP1SupFactoryKbnStr = this.supKbnList.find(
          (it) => it.value === item.didP1SupFactoryKbn
        )?.label;

        //処理2_工場
        item.didP2SupFactoryKbnStr = this.supKbnList.find(
          (it) => it.value === item.didP2SupFactoryKbn
        )?.label;
        //処理3_工場
        item.didP3SupFactoryKbnStr = this.supKbnList.find(
          (it) => it.value === item.didP3SupFactoryKbn
        )?.label;

        //処理1_加工単価(JPY)
        item.didP1UPrice = formatStringToCurrency(item.didP1UPrice);
        //処理2_加工単価(JPY)
        item.didP2UPrice = formatStringToCurrency(item.didP2UPrice);
        //処理3_加工単価(JPY)
        item.didP3UPrice = formatStringToCurrency(item.didP3UPrice);
        //加工_仕入先
        if (this.isEmptyOrNull(item.didMSupCode)) {
          item.didMSupFactoryKbn = STR_EMPTY;
          item.didMSupFactoryKbnStr = STR_EMPTY;
          item.didMCurType = STR_EMPTY;
          // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
          // 仕入先がNULLの場合、変更しない場合、閉じる時変更情報提示の問題の修正
          // item.didMExr = STR_EMPTY;
          item.didMExr = 0;
          // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

          item.didMUPriceJpy = STR_EMPTY;
          item.didMUPriceCny = STR_EMPTY;
          item.didMUTransportCostCny = STR_EMPTY;
          // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
          //仕入先がNULLの場合、変更しない場合、閉じる時変更情報提示の問題の修正
          // item.didMCommissionRate = STR_EMPTY;
          item.didMCommissionRate = 0;
          // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

          item.didMUPurchasePriceJpy = STR_EMPTY;
          item.didMUPurchasePriceCny = STR_EMPTY;
        }
        if (this.isEmptyOrNull(item.didP1SupCode)) {
          item.didP1SupFactoryKbn = STR_EMPTY;
          item.didP1SupFactoryKbnStr = STR_EMPTY;
          item.didP1UPrice = STR_EMPTY;
        }
        if (this.isEmptyOrNull(item.didP2SupCode)) {
          item.didP2SupFactoryKbn = STR_EMPTY;
          item.didP2SupFactoryKbnStr = STR_EMPTY;
          item.didP2UPrice = STR_EMPTY;
        }
        if (this.isEmptyOrNull(item.didP3SupCode)) {
          item.didP3SupFactoryKbn = STR_EMPTY;
          item.didP3SupFactoryKbnStr = STR_EMPTY;
          item.didP3UPrice = STR_EMPTY;
        }

        // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // if (this.misumiKbnIsNotPurchased(item.didMisumiKbn)) {
        //   // 売価(JPY/个)
        //   item.didUSalesPrice = NUM_ZERO;
        // } else {
        //   // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
        //   //売価(JPY/个)
        //   item.didUSalesPrice = formatStringToCurrency(
        //     (formatCurrencyToNumber(item.didMUPurchasePriceJpy) +
        //       (isNaN(formatCurrencyToNumber(item.didP1UPrice))
        //         ? 0
        //         : formatCurrencyToNumber(item.didP1UPrice)) +
        //       (isNaN(formatCurrencyToNumber(item.didP2UPrice))
        //         ? 0
        //         : formatCurrencyToNumber(item.didP2UPrice)) +
        //       (isNaN(formatCurrencyToNumber(item.didP3UPrice))
        //         ? 0
        //         : formatCurrencyToNumber(item.didP3UPrice))) /
        //       (1 -
        //         (isNaN(item.didGrossMargin) ? 0 : item.didGrossMargin) * 0.01)
        //   );
        // }
        //売価(JPY/个)
        item.didUSalesPrice = NUM_ZERO;
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

        //確定売価
        item.didUSetPrice = formatStringToCurrency(
          formatCurrencyToNumber(item.didUSetPrice)
        );

        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        // 受注日(yy/MM/dd)
        item.didAcceptDateShow = formatDateToShortYear(item.didAcceptDate);
        // 納期(yy/MM/dd)
        item.didCusDeliveryDateShow = formatDateToShortYear(
          item.didCusDeliveryDate
        );

        // 数量 (単位)
        item.didProdQtyUnit =
          item.didProdQuantity + " (" + (item.didProdUnit ?? STR_EMPTY) + ") ";

        // 工場 (貨幣)
        item.didSupFacKbnCurType =
          (item.didMSupFactoryKbnStr ?? STR_EMPTY) +
          (item.didMCurType == STR_EMPTY
            ? STR_EMPTY
            : " (" + item.didMCurType + ") ");

        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

        return item;
      });

      //読み込み回数=1
      if (this.numLoads == 1) {
        //比較用詳細情報
        this.cmpDetailResult = JSON.parse(
          JSON.stringify(this.extract(this.dataImportTable))
        );
        this.numLoads = this.numLoads + 1;
      }
    },

    //セルの編集
    editCellData(row, column, cell, event) {
      //受注済みの場合、編集不可
      // if (!this.notAcceptedFlg) {
      //   return "";
      // }

      //編集可能な列:
      //「得意先」「得意先担当者」「注番」「重量」
      //「加工_仕入先」「加工_レート」「加工_加工単価(JPY)」「加工_加工単価(CNY)」「加工_運賃(CNY/个)」「加工_提成率（%）」
      //「処理1_仕入先」「処理1_加工単価(JPY)」「処理2_仕入先」「処理2_加工単価(JPY)」「処理3_仕入先」「処理3_加工単価(JPY)」
      //「粗利率(%)」「確定売価」
      var columnEditable = [
        "didCusCode",
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // 得意先担当者：変更不可
        // "didCusUserCode",
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        "didCusOrderNo",
        "didUWeight",
        "didMSupCode",
        "didMExr",
        "didMUPriceJpy",
        "didMUPriceCny",
        "didMUTransportCostCny",
        "didMCommissionRate",
        "didP1SupCode",
        "didP1UPrice",
        "didP2SupCode",
        "didP2UPrice",
        "didP3SupCode",
        "didP3UPrice",
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // "didGrossMargin",
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        "didUSetPrice",
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        "didUSalesPrice", // 売価
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
        "didMisumiKbn", // ミスミ関連区分
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
      ];
      //仕入先が空の場合、加工単価が編集不可
      if (this.isEmptyOrNull(row.didP1SupCode)) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didP1UPrice"
        );
      }
      if (this.isEmptyOrNull(row.didP2SupCode)) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didP2UPrice"
        );
      }
      if (this.isEmptyOrNull(row.didP3SupCode)) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didP3UPrice"
        );
      }

      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
      if (column.property == "didCusOrderNo" && row.didCusOrderNo.length > 10) {
        //注番の列幅フラグ（true:増加）
        this.didCusOrderNoChangeWidth = true;
      }
      // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

      //見積タイプが「製品」以外の場合、重量と運賃(CNY)と提成率(%)と処理が編集不可
      if (row.didType != t("resource.DATA_IMPORT.PRODUCT")) {
        columnEditable = columnEditable.filter(
          (item) =>
            // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
            // item !== "didUWeight" &&
            // item !== "didMUTransportCostCny" &&
            // item !== "didMCommissionRate" &&
            // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

            item !== "didP1SupCode" &&
            item !== "didP1UPrice" &&
            item !== "didP2SupCode" &&
            item !== "didP2UPrice" &&
            item !== "didP3SupCode" &&
            item !== "didP3UPrice"
        );
      }

      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      var ASetDataFlg = this.dataImportTable.some(
        (row) => row.didProdUnit === UNIT_SET
      );

      if (ASetDataFlg && row.didProdUnit !== UNIT_SET) {
        columnEditable = columnEditable.filter(
          (item) =>
            item !== "didP1UPrice" &&
            item !== "didP2UPrice" &&
            item !== "didP3UPrice"
        );
      }
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
      //ミスミ仕入先&&購入品以外の場合、処理1～3を表示しない
      if (this.misumiKbnIsNotPurchased(row.didMisumiKbn)) {
        columnEditable = columnEditable.filter(
          (item) =>
            item !== "didP1SupCode" &&
            item !== "didP1UPrice" &&
            item !== "didP2SupCode" &&
            item !== "didP2UPrice" &&
            item !== "didP3SupCode" &&
            item !== "didP3UPrice"
        );
      }
      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

      // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
      // if (row.didMSupFactoryKbnStr == STR_EMPTY) {
      //   columnEditable = columnEditable.filter(
      //     (item) =>
      //       item !== "didMUPriceJpy" &&
      //       item !== "didMExr" &&
      //       item !== "didMUPriceCny" &&
      //       item !== "didMUTransportCostCny" &&
      //       item !== "didMCommissionRate"
      //   );
      // }
      //  else {
      //加工_仕入先が大連の場合、加工単価(JPY)が編集不可
      // if (row.didMSupFactoryKbnStr == STR_DALIAN) {
      //   columnEditable = columnEditable.filter(
      //     (item) => item !== "didMUPriceJpy"
      //   );
      // } else {
      //加工_仕入先が大連以外の場合、レート、加工単価(CNY)、運賃(CNY)、提成率(%)が編集不可
      //   columnEditable = columnEditable.filter(
      //     (item) =>
      //       item !== "didMExr" &&
      //       item !== "didMUPriceCny" &&
      //       item !== "didMUTransportCostCny" &&
      //       item !== "didMCommissionRate"
      //   );
      // }
      // }
      // DEL 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

      if (!columnEditable.includes(column.property)) {
        return false;
      }

      if (column.property == "didCusCode") {
        return "selectCustomer";
      }

      // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // 得意先担当者：変更不可
      /* if (column.property == "didCusUserCode") {
        return "selectCusUser";
      } */
      // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
      if (column.property == "didMisumiKbn") {
        return "selectMisumiKbn";
      }
      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

      if (
        column.property == "didMSupCode" ||
        column.property == "didP1SupCode" ||
        column.property == "didP2SupCode" ||
        column.property == "didP3SupCode"
      ) {
        return "selectSupplier";
      } else if (column.property == "didCusOrderNo") {
        return "text";
      } else if (
        column.property == "didMUPriceJpy" ||
        column.property == "didMUPriceCny" ||
        column.property == "didP1UPrice" ||
        column.property == "didP2UPrice" ||
        column.property == "didP3UPrice" ||
        // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓
        column.property == "didMUTransportCostCny" || // 運賃(CNY)
        column.property == "didUSalesPrice" || // 売価
        // ADD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑
        column.property == "didUSetPrice"
      ) {
        return "input";
      } else if (
        column.property == "didUWeight" ||
        column.property == "didMExr" ||
        column.property == "didMCommissionRate"
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // ||
        // column.property == "didGrossMargin"
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      ) {
        return "inputNumber";
      } else {
        return false;
      }
    },

    //セルの保存
    changeCellData() {
      this.dataProcess();
    },

    //入力ボックスをクリックすると、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },

    // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
    // 得意先担当者が空を表示し、関連チェックを削除する
    // //得意先の変更⇒得意先担当者の更新
    // changeSelectCustomer(data) {
    //   //得意先担当者リストの取得
    //   initDataImportDetailCusUserList({
    //     didCusCode: data.didCusCode,
    //   })
    //     .then((res) => {
    //       this.$nextTick(() => {
    //         this.dataImportTable[data.index].managerList = res.managerList;

    //         this.dataImportTable[data.index].didCusUserCode =
    //           res.managerList.length > 0 ? res.managerList[0].mgrCode : "";
    //       });
    //     })
    //     .catch((err) => {
    //       this.showFlag = false;
    //       if (err.data != null) {
    //         Message.showError(
    //           t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
    //         );
    //       } else {
    //         Message.showError(
    //           t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
    //         );
    //       }
    //     })
    //     .finally(() => {
    //       this.showFlag = false;
    //     });
    // },
    // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

    //仕入先の変更⇒工場の更新
    changeSelectSupplier(row, col) {
      this.dataImportTable.map((item) => {
        if (row.index == item.index) {
          if (col.property == "didMSupCode") {
            //加工_工場Kbn
            item.didMSupFactoryKbn = this.supplierList.find(
              (it) => it.supCode === row.didMSupCode
            )?.supFactoryKbn;

            //加工_工場字
            item.didMSupFactoryKbnStr = this.supKbnList.find(
              (it) => it.value === item.didMSupFactoryKbn
            )?.label;

            //加工_貨幣タイプ
            item.didMCurType =
              item.didMSupFactoryKbnStr == STR_DALIAN ? "CNY" : "JPY";

            //加工:大連工場以外の場合、レート＝1、加工単価(CNY)＝0、運賃(CNY)＝0、提成率(%)＝0、仕入価格(CNY)＝0
            if (item.didMSupFactoryKbnStr != STR_DALIAN) {
              item.didMExr = 1;
              item.didMUPriceCny = 0;
              item.didMUTransportCostCny = 0;
              item.didMCommissionRate = 0;
              item.didMUPurchasePriceCny = 0;

              // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
              // 課題_同じ通貨幣タイプ仕入先変更で、レートと加工単価が変更されない問題の改善
              // item.didMUPriceJpy = 0;
              // item.didMUPurchasePriceJpy = 0;

              item.didMUPriceJpy = item.didMUPriceJpy;
              item.didMUPurchasePriceJpy = item.didMUPurchasePriceJpy;
              // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑
            } else {
              item.didMExr = item.didMExr;
              // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
              // 課題_同じ通貨幣タイプ仕入先変更で、レートと加工単価が変更されない問題の改善
              // item.didMUPriceCny = 0;
              // item.didMUTransportCostCny = 0;
              // item.didMCommissionRate = 0;
              // item.didMUPurchasePriceCny = 0;

              item.didMUPriceCny = item.didMUPriceCny;
              item.didMUTransportCostCny = item.didMUTransportCostCny;
              item.didMCommissionRate = item.didMCommissionRate;
              item.didMUPurchasePriceCny = item.didMUPurchasePriceCny;
              // UPD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑

              item.didMUPriceJpy = 0;
              item.didMUPurchasePriceJpy = 0;
            }

            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
            // ミスミ仕入先以外またはミスミ仕入先&&金額調整の場合、ミスミ関連区分が"-"を表示する
            if (
              this.isNotMisumiSupplier(row) ||
              this.isMisumiSupplierAndSupplemental(row)
            ) {
              item.didMisumiKbn = STR_ZERO;
            } else {
              item.didMisumiKbn = item.didMisumiKbn;
            }
            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
          }
          if (col.property == "didP1SupCode") {
            if (!this.isEmptyOrNull(item.didP1SupCode)) {
              item.didP1SupFactoryKbn = this.supplierList.find(
                (s) => s.supCode == item.didP1SupCode
              )?.supFactoryKbn;
              item.didP1SupFactoryKbnStr = this.supKbnList.find(
                (it) => it.value === item.didP1SupFactoryKbn
              )?.label;
            }
          }

          if (col.property == "didP2SupCode") {
            if (!this.isEmptyOrNull(item.didP2SupCode)) {
              item.didP2SupFactoryKbn = this.supplierList.find(
                (s) => s.supCode == item.didP2SupCode
              )?.supFactoryKbn;
              item.didP2SupFactoryKbnStr = this.supKbnList.find(
                (it) => it.value === item.didP2SupFactoryKbn
              )?.label;
            }
          }

          if (col.property == "didP3SupCode") {
            if (!this.isEmptyOrNull(item.didP3SupCode)) {
              item.didP3SupFactoryKbn = this.supplierList.find(
                (s) => s.supCode == item.didP3SupCode
              )?.supFactoryKbn;
              item.didP3SupFactoryKbnStr = this.supKbnList.find(
                (it) => it.value === item.didP3SupFactoryKbn
              )?.label;
            }
          }
        }
        return item;
      });
      this.dataProcess();
    },

    //入力チェック
    inputCheck() {
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // 一式機能の追加
      var ASetDataFlg = this.dataImportTable.some(
        (row) => row.didProdUnit === UNIT_SET
      );
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      for (var index = 0; index < this.dataImportTable.length; index++) {
        const row = this.dataImportTable[index];

        //製品情報:「設計」または「図番、品名」(製品、金額調整)
        // var productionInfo;
        // if (
        //   this.isEmptyOrNull(row.didProdDrawNo) &&
        //   this.isEmptyOrNull(row.didProdName)
        // ) {
        //   productionInfo = t("resource.DATA_IMPORT.DESIGN");
        // } else {
        //   productionInfo = row.didProdDrawNo + "、" + row.didProdName;
        // }

        //製品情報 =「図番、品名」または「図番」または「品名」
        var productionInfo;
        if (
          !this.isEmptyOrNull(row.didProdDrawNo) &&
          !this.isEmptyOrNull(row.didProdName)
        ) {
          productionInfo = row.didProdDrawNo + "、" + row.didProdName;
        } else {
          productionInfo = !this.isEmptyOrNull(row.didProdDrawNo)
            ? row.didProdDrawNo
            : row.didProdName;
        }

        //得意先
        if (this.isEmptyOrNull(row.didCusCode)) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.NULL_VALUE")
              .replace("{0}", productionInfo)
              .replace("{1}", t("resource.DATA_IMPORT.CUS_CODE"))
              .replace("{2}", t("resource.DATA_IMPORT.BASIC_INFO")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        // UPD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
        ////「得意先」は「取込担当者」に対応する「得意先」ではない
        //if (this.cusCodeByDibUserCodeList.indexOf(row.didCusCode) == -1) {
        //「得意先」は「受注担当者」に対応する「得意先」ではない
        if (row.cusCodeByaodUserCodeList.indexOf(row.didCusCode) == -1) {
          // UPD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.CUSTOMER_NOT_BELONGS_TO_USER")
              .replace("{0}", productionInfo)
              .replace("{1}", t("resource.DATA_IMPORT.CUS_CODE"))
              .replace("{2}", t("resource.DATA_IMPORT.BASIC_INFO")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        //「得意先」は「見積No.」に対応する「得意先」ではない
        if (row.didQuoteNo.split("-")[1] != row.didCusCode) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.CUSTOMER_NOT_BELONGS_TO_QUOTE_NO")
              .replace("{0}", productionInfo)
              .replace("{1}", t("resource.DATA_IMPORT.CUS_CODE"))
              .replace("{2}", t("resource.DATA_IMPORT.BASIC_INFO")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // 得意先担当者の変更:得意先担当者が空を表示する
        // //得意先担当者
        // if (this.isEmptyOrNull(row.didCusUserCode)) {
        //   Modal.showWarning(
        //     "",
        //     t("message.DATA_IMPORT.NULL_VALUE")
        //       .replace("{0}", productionInfo)
        //       .replace("{1}", t("resource.DATA_IMPORT.CUS_USER_CODE"))
        //       .replace("{2}", t("resource.DATA_IMPORT.BASIC_INFO")),
        //     {
        //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //     }
        //   );
        //   return false;
        // }
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 運賃(CNY)と重量の連携計算ロジックの削除(25.2対応漏れ)
        //// 重量の入力チェック:（製品）加工_加工単価(CNY)>1000の場合、重量は有効値である
        // if (
        //   row.didType == STR_DID_TYPE_PRODUCT &&
        //   row.didMSupFactoryKbn == FACTORY_KBN_DALIAN &&
        //   formatCurrencyToNumber(row.didMUPriceCny) > 1000 &&
        //   formatCurrencyToNumber(row.didUWeight) == 0
        // ) {
        //   Modal.showWarning(
        //     "",
        //     t("message.DATA_IMPORT.NULL_VALUE")
        //       .replace("{0}", productionInfo)
        //       .replace("{1}", t("resource.DATA_IMPORT.U_WEIGHT"))
        //       .replace("{2}", t("resource.DATA_IMPORT.PRODUCT_INFO")),
        //     {
        //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //     }
        //   );
        //   return false;
        // }
        // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        //加工_仕入先
        if (this.isEmptyOrNull(row.didMSupCode)) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.NULL_VALUE")
              .replace("{0}", productionInfo)
              .replace("{1}", t("resource.DATA_IMPORT.SUPPLIER"))
              .replace("{2}", t("resource.DATA_IMPORT.MAIN_PROCESSING")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        //レート「大連工場の場合」
        if (
          row.didMSupFactoryKbn == FACTORY_KBN_DALIAN &&
          formatCurrencyToNumber(row.didMExr) == 0
        ) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.NULL_VALUE")
              .replace("{0}", productionInfo)
              .replace("{1}", t("resource.DATA_IMPORT.EXCHANGE_RATE"))
              .replace("空", "0")
              .replace("{2}", t("resource.DATA_IMPORT.MAIN_PROCESSING")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // if (row.didType == t("resource.DATA_IMPORT.PRODUCT")) {
        //   //加工_加工単価(CNY)「大連工場の場合」
        //   if (
        //     row.didMSupFactoryKbn == FACTORY_KBN_DALIAN &&
        //     (this.isEmptyOrNull(row.didMUPriceCny) ||
        //       formatCurrencyToNumber(row.didMUPriceCny) == 0) &&
        //     // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        //     // 一式機能の追加
        //     (!ASetDataFlg || (ASetDataFlg && row.didProdUnit === UNIT_SET)) // 一式データ以外の場合
        //     // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        //   ) {
        //     Modal.showWarning(
        //       "",
        //       t("message.DATA_IMPORT.NULL_VALUE")
        //         .replace("{0}", productionInfo)
        //         .replace("{1}", t("resource.DATA_IMPORT.U_PRICE_CNY"))
        //         .replace("{2}", t("resource.DATA_IMPORT.MAIN_PROCESSING")),
        //       {
        //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //       }
        //     );
        //     return false;
        //   }
        // }

        // //製品の加工単価が空できない
        // if (row.didType == t("resource.DATA_IMPORT.PRODUCT")) {
        //   //加工_加工単価(JPY)
        //   if (
        //     (this.isEmptyOrNull(row.didMUPriceJpy) ||
        //       formatCurrencyToNumber(row.didMUPriceJpy) == 0) &&
        //     // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        //     // 一式機能の追加
        //     (!ASetDataFlg || (ASetDataFlg && row.didProdUnit === UNIT_SET)) // 一式データ以外の場合
        //     // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        //   ) {
        //     Modal.showWarning(
        //       "",
        //       t("message.DATA_IMPORT.NULL_VALUE")
        //         .replace("{0}", productionInfo)
        //         .replace("{1}", t("resource.DATA_IMPORT.U_PRICE_JPY"))
        //         .replace("{2}", t("resource.DATA_IMPORT.MAIN_PROCESSING")),
        //       {
        //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //       }
        //     );
        //     return false;
        //   }
        // }

        // //処理1_加工単価(JPY)
        // if (
        //   !this.isEmptyOrNull(row.didP1SupCode) &&
        //   (this.isEmptyOrNull(row.didP1UPrice) ||
        //     formatCurrencyToNumber(row.didP1UPrice) == 0) &&
        //   // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        //   // 一式機能の追加
        //   (!ASetDataFlg || (ASetDataFlg && row.didProdUnit === UNIT_SET)) // 一式データ以外の場合
        //   // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        // ) {
        //   Modal.showWarning(
        //     "",
        //     t("message.DATA_IMPORT.NULL_VALUE")
        //       .replace("{0}", productionInfo)
        //       .replace("{1}", t("resource.DATA_IMPORT.U_PRICE"))
        //       .replace("{2}", t("resource.DATA_IMPORT.PROCESSING_ONE")),
        //     {
        //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //     }
        //   );
        //   return false;
        // }
        // //処理2_加工単価(JPY)
        // if (
        //   !this.isEmptyOrNull(row.didP2SupCode) &&
        //   (this.isEmptyOrNull(row.didP2UPrice) ||
        //     formatCurrencyToNumber(row.didP2UPrice) == 0) &&
        //   // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        //   // 一式機能の追加
        //   (!ASetDataFlg || (ASetDataFlg && row.didProdUnit === UNIT_SET)) // 一式データ以外の場合
        //   // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        // ) {
        //   Modal.showWarning(
        //     "",
        //     t("message.DATA_IMPORT.NULL_VALUE")
        //       .replace("{0}", productionInfo)
        //       .replace("{1}", t("resource.DATA_IMPORT.U_PRICE"))
        //       .replace("{2}", t("resource.DATA_IMPORT.PROCESSING_TWO")),
        //     {
        //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //     }
        //   );
        //   return false;
        // }

        // //処理3_加工単価(JPY)
        // if (
        //   !this.isEmptyOrNull(row.didP3SupCode) &&
        //   (this.isEmptyOrNull(row.didP3UPrice) ||
        //     formatCurrencyToNumber(row.didP3UPrice) == 0) &&
        //   // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        //   // 一式機能の追加
        //   (!ASetDataFlg || (ASetDataFlg && row.didProdUnit === UNIT_SET)) // 一式データ以外の場合
        //   // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        // ) {
        //   Modal.showWarning(
        //     "",
        //     t("message.DATA_IMPORT.NULL_VALUE")
        //       .replace("{0}", productionInfo)
        //       .replace("{1}", t("resource.DATA_IMPORT.U_PRICE"))
        //       .replace("{2}", t("resource.DATA_IMPORT.PROCESSING_THREE")),
        //     {
        //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //     }
        //   );
        //   return false;
        // }
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

        // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
        //製品の確定売価が空できない
        // if (row.didType == t("resource.DATA_IMPORT.PRODUCT")) {

        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // 確定売価が空のチェックを削除する
        // //製品の確定売価が空できない
        // // ミスミ関連区分は「担当組付、社内組付、社内加工、ミスミ大連」の確定売価が空できる
        // if (
        //   row.didType == t("resource.DATA_IMPORT.PRODUCT") &&
        //   !this.misumiKbnIsNotPurchased(row.didMisumiKbn)
        // ) {
        //   // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

        //   //確定売価
        //   if (
        //     (this.isEmptyOrNull(row.didUSetPrice) ||
        //       formatCurrencyToNumber(row.didUSetPrice) == 0) &&
        //     // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        //     // 一式機能の追加
        //     (!ASetDataFlg || (ASetDataFlg && row.didProdUnit === UNIT_SET)) // 一式データ以外の場合
        //     // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        //   ) {
        //     Modal.showWarning(
        //       "",
        //       t("message.DATA_IMPORT.NULL_VALUE")
        //         .replace("{0}", productionInfo)
        //         .replace("{1}", t("resource.DATA_IMPORT.U_SET_PRICE"))
        //         .replace("{2}", t("resource.DATA_IMPORT.QUOTE_INFO")),
        //       {
        //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        //       }
        //     );
        //     return false;
        //   }
        // }
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

        //設計または金額調整の「加工単価」と「確定売価」には少なくとも1つの値がある
        if (row.didType != t("resource.DATA_IMPORT.PRODUCT")) {
          //加工_加工単価(JPY)
          if (
            (this.isEmptyOrNull(row.didMUPriceJpy) ||
              formatCurrencyToNumber(row.didMUPriceJpy) == 0) &&
            (this.isEmptyOrNull(row.didUSetPrice) ||
              formatCurrencyToNumber(row.didUSetPrice) == 0)
          ) {
            Modal.showWarning(
              "",
              t("message.DATA_IMPORT.NULL_VALUE")
                .replace("{0}", productionInfo)
                .replace(
                  "{1}",
                  t("resource.DATA_IMPORT.U_PRICE_JPY") +
                    "または" +
                    t("resource.DATA_IMPORT.U_SET_PRICE")
                )
                .replace(
                  "{2}",
                  t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                    "または" +
                    t("resource.DATA_IMPORT.QUOTE_INFO")
                ),
              {
                confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
              }
            );
            return false;
          }
        }

        //加工と処理1と処理2と処理3の仕入先が同じではありません
        let supCodes = [
          row.didMSupCode,
          row.didP1SupCode,
          row.didP2SupCode,
          row.didP3SupCode,
        ].filter((supCode) => !this.isEmptyOrNull(supCode));

        let supCodesSet = new Set(supCodes);

        if (supCodesSet.size < supCodes.length) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.SUPPLIER_SHOULD_DIFFERENT").replace(
              "{0}",
              productionInfo
            ),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }

        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
        // ミスミ仕入先の場合、ミスミ関連区分が選択しない場合、提示メッセージを表示する
        if (
          !this.isNotMisumiSupplier(row) &&
          row.didMisumiKbn === STR_ZERO &&
          row.didType !== STR_SUPPLEMENTAL
        ) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.IS_NOT_SELECT_MISUMIKBN").replace(
              "{0}",
              productionInfo
            ),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
      }

      //同見積No.の基本情報一致のチェック
      //[{aa1,bb1,cc1},{aa2,bb2,cc2}]⇒[{"1":"aa1","2":"bb1","3":"cc1"},{"1":"aa2","2":"bb2","3":"cc2"}]
      let jsonArray = [];
      for (let i = 0; i < this.dataImportTable.length; i++) {
        let obj = {
          quoteNo: this.dataImportTable[i].didQuoteNo,
          cusCode: this.dataImportTable[i].didCusCode,
          // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          // cusUserCode: this.dataImportTable[i].didCusUserCode,
          // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
          cusOrderNo: this.dataImportTable[i].didCusOrderNo,
        };
        jsonArray.push(obj);
      }

      //[{"1":"aa1","2":"bb1","3":"cc1"},{"1":"aa2","2":"bb2","3":"cc2"}]⇒[{"1":[aa1,aa2]},{"2":[bb1,bb2]},{"3":[cc1,cc2]}]
      const cusCodeMap = new Map();
      const cusUserCodeMap = new Map();
      const cusOrderNoMap = new Map();
      jsonArray.forEach((obj) => {
        const { quoteNo, cusCode, cusUserCode, cusOrderNo } = obj;

        if (cusCodeMap.has(quoteNo)) {
          cusCodeMap.get(quoteNo).push(cusCode);
          cusUserCodeMap.get(quoteNo).push(cusUserCode);
          cusOrderNoMap.get(quoteNo).push(cusOrderNo);
        } else {
          cusCodeMap.set(quoteNo, [cusCode]);
          cusUserCodeMap.set(quoteNo, [cusUserCode]);
          cusOrderNoMap.set(quoteNo, [cusOrderNo]);
        }
      });

      var checkFlg = true;
      //得意先が一致しない場合
      cusCodeMap.forEach((cusCodeArr, quoteNo) => {
        const uniqueCusCodes = [...new Set(cusCodeArr)];
        if (uniqueCusCodes.length > 1) {
          checkFlg = false;
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.DIFFERENT_BASIC_INFO")
              .replace("{0}", quoteNo)
              .replace("{1}", t("resource.DATA_IMPORT.CUS_CODE")),
            {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            }
          );
          return false;
        }
      });
      if (!checkFlg) {
        return false;
      }

      // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // 得意先担当者が空を表示し、関連チェックを削除する
      // //得意先担当者コードが一致しない場合
      // // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      // // [最後]→[最初]の異常を表示するメッセージの修正
      // // cusUserCodeMap.forEach((cusUserCodeArr, quoteNo) => {
      // for (const [quoteNo, cusUserCodeArr] of cusUserCodeMap) {
      //   // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      //   const uniqueCusUserCodes = [...new Set(cusUserCodeArr)];
      //   if (uniqueCusUserCodes.length > 1) {
      //     checkFlg = false;
      //     Modal.showWarning(
      //       "",
      //       t("message.DATA_IMPORT.DIFFERENT_BASIC_INFO")
      //         .replace("{0}", quoteNo)
      //         .replace("{1}", t("resource.DATA_IMPORT.CUS_USER_CODE")),
      //       {
      //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //       }
      //     );
      //     // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      //     // return false;
      //     break;
      //     // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      //   }
      //   // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
      //   // });
      // }
      // // UPD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
      // if (!checkFlg) {
      //   return false;
      // }
      // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑

      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      //// 注番が一致しない場合
      // cusOrderNoMap.forEach((cusOrderNoArr, quoteNo) => {
      //   const uniqueCusOrderNos = [...new Set(cusOrderNoArr)];
      //   if (uniqueCusOrderNos.length > 1) {
      //     checkFlg = false;
      //     Modal.showWarning(
      //       "",
      //       t("message.DATA_IMPORT.DIFFERENT_BASIC_INFO")
      //         .replace("{0}", quoteNo)
      //         .replace("{1}", t("resource.DATA_IMPORT.CUS_ORDER_NO")),

      //       {
      //         confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //       }
      //     );
      //     return false;
      //   }
      // });
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑
      if (!checkFlg) {
        return false;
      }

      return true;
    },

    //削除ボタン
    deleteClick() {
      this.showFlag = true;
      let state = this.dataImportEditForm.dibAcceptState;
      ShowRemovableQuoteNoDialog(
        {
          dataImportNo: this.dataImportNo,
        },
        t("resource.DATA_IMPORT.REMOVE_QUOTE_NO_VIEW"),
        (target) => {
          if (target != undefined) {
            //変更前が「1：受注待ち」と すべての受注取込データを削除した場合、初期化
            if (state == DIB_ACCEPT_ORDER_WAITING && target) {
              this.localIsAdd = true;
              this.dataImportTable = [];
              this.init();
            } else {
              this.numLoads = 1;
              this.searchDataImportDetailByDibNoProc();
            }
          }
          this.showFlag = false;
        }
      );
      //フォーカス削除
      this.$refs.delBtn.$el.blur();
    },

    //受注データ取込ボタン
    dataImportClick() {
      if (!this.localIsAdd) {
        //編集の場合、再度取込
        return Modal.showWarning(
          "",
          t("message.DATA_IMPORT.DATA_IMPORT_AGAIN"),
          {
            $type: "prompt",
            confirmButtonText: t("resource.button.sure"),
            cancelButtonText: t("resource.button.cancel"),
            showCancelButton: true,
          }
        )
          .then(() => {
            //再度取込-確定
            this.dataImportAgainFlag = true;
            //ファイル選択ボックスを開く
            this.openFileProc();
          })
          .catch((error) => {
            //再度取込-キャンセル
            return;
          });
      } else {
        //ファイル選択ボックスを開く
        this.openFileProc();
      }
    },

    //ファイル選択ボックスを開く
    openFileProc() {
      this.showFlag = true;
      const input = document.createElement("input");
      input.type = "file";
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // ファイル形式の変更：「xlsx」⇒「xlsm」
      // input.accept = ".xlsx";
      input.accept = ".xlsm";
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      input.addEventListener("change", (e) => {
        //ファイル形式がxlsxのチェック
        const file = e.target.files[0];
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // ファイル形式の変更：「xlsx」⇒「xlsm」
        // if (!file || !file.name.endsWith(".xlsx")) {
        if (!file || !file.name.endsWith(".xlsm")) {
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          this.showWarningMessage(t("message.DATA_IMPORT.FILE_TYPE_NOT_XLSX"));
          return;
        }

        //ファイルサイズが5M以内のチェック
        let maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
          this.showWarningMessage(t("message.DATA_IMPORT.FILE_SIZE_ERROR"));
          return;
        }

        this.readDataFromXLSX(file)
          .then((result) => {
            if (result.length > 0) {
              if (
                //result[0][0].toString() != t("resource.DATA_IMPORT.BASIC_INFO") ||
                result[0][t("resource.DATA_IMPORT.QUOTE_NO")] !=
                t("resource.DATA_IMPORT.QUOTE_NO")
              ) {
                this.showWarningMessage(
                  t("message.DATA_IMPORT.FILE_NOT_FORMAT")
                );
                return;
              }

              //データ
              //var tmpTableData = result.slice(2);
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // 見積NO.が空のデータは取得しない
              // var tmpTableData = result.slice(1);
              //
              var tmpTableData = result
                .map((row, index) => ({ ...row, rowIndex: index + 2 }))
                .slice(1)
                .filter(
                  (row) =>
                    row[t("resource.DATA_IMPORT.QUOTE_NO")] != null &&
                    row[t("resource.DATA_IMPORT.QUOTE_NO")] !== ""
                );
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              //取込の受注データをチェックする
              // var msg = this.importCheck(tmpTableData);

              //取込の得意先リスト
              //　見積NO.の 得意先リスト
              var cusCodeList = [
                ...new Set(
                  tmpTableData
                    .map((row) => row[t("resource.DATA_IMPORT.QUOTE_NO")])
                    .filter((v) => v != null && v !== "")
                    .map((v) => v.split("-")[1] || "")
                    .filter(Boolean)
                ),
              ];
              var customerForUserList = {};

              // 得意先コードリスト(受注担当者コードで）の取得
              getCusCodeForUserInfo({ cusCodeList: cusCodeList })
                .then((res) => {
                  customerForUserList = res;
                })
                .finally(() => {
                  var msg = this.importCheck(tmpTableData, customerForUserList);
                  // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

                  //取込の受注データの問題がない場合、
                  if (this.isEmptyOrNull(msg)) {
                    //取込時間
                    this.dataImportEditForm.dibImportTime =
                      formatSystemTimeToyyyyMMddHHmmss(
                        new Date(),
                        "yyyy/MM/dd HH:mm:ss"
                      );

                    //ファイル名
                    this.dataImportEditForm.dibFileName = file.name;

                    //受注状態
                    this.dataImportEditForm.dibAcceptState =
                      this.statusList.length > 0
                        ? this.statusList[0].value
                        : "";

                    //取込の得意先リスト
                    let cusCodeList = [];
                    for (var i = 0; i < tmpTableData.length; i++) {
                      //得意先コード
                      var didCusCode = this.customerList.find(
                        (it) =>
                          // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
                          // it.cusAbbreviation ===
                          //   tmpTableData[i][t("resource.DATA_IMPORT.CUS_CODE")]

                          it.cusAbbreviation ===
                          tmpTableData[i][
                            t("resource.DATA_IMPORT.BASIC_INFO") +
                              STR_UNDERLINE +
                              t("resource.DATA_IMPORT.CUS_CODE")
                          ]
                        // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
                      )?.cusCode;

                      //重複除去
                      if (
                        cusCodeList.indexOf(didCusCode) == -1 &&
                        !this.isEmptyOrNull(didCusCode)
                      ) {
                        cusCodeList.push(didCusCode);
                      }
                    }

                    //得意先担当者リストの取得
                    initDataImportDetailCusUserList({
                      cusCodeList: cusCodeList,
                    })
                      .then((res) => {
                        //受注データ取込テーブルTmp
                        var fileJsonData = [];

                        // 一式機能の追加
                        var setDataFlg = tmpTableData.some(
                          (row) =>
                            row[t("resource.DATA_IMPORT.PROD_UNIT")] ==
                              UNIT_SET &&
                            row[
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ].toString() !=
                              t("resource.DATA_IMPORT.SUPPLEMENTAL")
                        );

                        for (var i = 0; i < tmpTableData.length; i++) {
                          // DEL 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                          // var typeIsProduct =
                          //   tmpTableData[i][
                          //     t("resource.DATA_IMPORT.PROD_TYPE")
                          //   ].toString() == t("resource.DATA_IMPORT.PRODUCT");
                          // DEL 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

                          //得意先
                          var didCusCode = this.customerList.find(
                            (it) =>
                              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
                              // it.cusAbbreviation ===
                              // tmpTableData[i][t("resource.DATA_IMPORT.CUS_CODE")]
                              it.cusAbbreviation ===
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.BASIC_INFO") +
                                  STR_UNDERLINE +
                                  t("resource.DATA_IMPORT.CUS_CODE")
                              ]
                            // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
                          )?.cusCode;
                          didCusCode =
                            didCusCode == undefined ? "" : didCusCode;

                          //得意先担当者リスト
                          var managerList =
                            didCusCode == "" ? [] : res.managerList[didCusCode];

                          var didCusUserCode =
                            managerList.find(
                              (it) =>
                                // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
                                // it.mgrAbbreviation ===
                                // tmpTableData[i][
                                //   t("resource.DATA_IMPORT.CUS_USER_CODE")
                                // ]
                                it.mgrAbbreviation ===
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.BASIC_INFO") +
                                    STR_UNDERLINE +
                                    t("resource.DATA_IMPORT.CUS_USER_CODE")
                                ]
                              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
                            )?.mgrCode == undefined
                              ? ""
                              : managerList.find(
                                  (it) =>
                                    // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
                                    // it.mgrAbbreviation ===
                                    // tmpTableData[i][
                                    //   t("resource.DATA_IMPORT.CUS_USER_CODE")
                                    // ]
                                    it.mgrAbbreviation ===
                                    tmpTableData[i][
                                      t("resource.DATA_IMPORT.BASIC_INFO") +
                                        STR_UNDERLINE +
                                        t("resource.DATA_IMPORT.CUS_USER_CODE")
                                    ]
                                  // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
                                )?.mgrCode;

                          // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
                          // ミスミ関連区分: 初期値：‐
                          var misumiKbnLabel = STR_HYPHEN;
                          if (
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ] == t("resource.DATA_IMPORT.MSM_PURCHASED") ||
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ] == t("resource.DATA_IMPORT.MSM_ASSEMBLY") ||
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ] ==
                              t("resource.DATA_IMPORT.MSM_IN_CMP_ASSEMBLY") ||
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ] ==
                              t("resource.DATA_IMPORT.MSM_IN_CMP_PROCESSING") ||
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ] == t("resource.DATA_IMPORT.MSM_DL")
                          ) {
                            //ミスミ関連区分が見積タイプの値を表示する
                            misumiKbnLabel =
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ];
                          }

                          //確定売価 ミスミ仕入先の場合、ミスミ関連区分は「担当組付、社内組付、社内加工、ミスミ大連」の場合、確定売価が0
                          var uSetPriceVal =
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.U_SET_PRICE")
                            ];

                          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                          // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                          // 売価が非表示の変更
                          // var uSalesPriceVal =
                          //   tmpTableData[i][
                          //     t("resource.DATA_IMPORT.U_SALES_PRICE")
                          //   ];
                          // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

                          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                          // ミスミ仕入先のチェック　⇒　関連仕入先区分のチェック
                          // if (
                          //   !this.isEmptyOrNull(
                          //     tmpTableData[i][t("resource.DATA_IMPORT.SUPPLIER")]
                          //   ) &&
                          //   tmpTableData[i][
                          //     t("resource.DATA_IMPORT.SUPPLIER")
                          //   ].includes(STR_MISUMI)
                          // ) {
                          //　関連仕入先区分の追加
                          if (
                            !this.isEmptyOrNull(
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.SUPPLIER")
                              ]
                            ) &&
                            this.supplierList.find(
                              (it) =>
                                it.supAbbreviation ===
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.SUPPLIER")
                                ]
                            )?.supRelateFlag == STR_ONE
                          ) {
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                            if (
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] == t("resource.DATA_IMPORT.MSM_ASSEMBLY") ||
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] ==
                                t("resource.DATA_IMPORT.MSM_IN_CMP_ASSEMBLY") ||
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] ==
                                t(
                                  "resource.DATA_IMPORT.MSM_IN_CMP_PROCESSING"
                                ) ||
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] == t("resource.DATA_IMPORT.MSM_DL")
                            ) {
                              uSetPriceVal = STR_ZERO;
                              // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                              // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                              // 売価が非表示の変更
                              // uSalesPriceVal = STR_ZERO;
                              // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                              // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                            }
                          }
                          // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

                          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                          // 担当組付、社内組付、社内加工、ミスミ大連の場合、「処理123」を表示しない
                          var procShowKbn =
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ].toString() == t("resource.DATA_IMPORT.PRODUCT") ||
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ].toString() ==
                              t("resource.DATA_IMPORT.MSM_PURCHASED");

                          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

                          //見積タイプ デフォルト値：製品
                          if (
                            !(
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] == t("resource.DATA_IMPORT.PRODUCT") ||
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] == t("resource.DATA_IMPORT.DESIGN") ||
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ] == t("resource.DATA_IMPORT.SUPPLEMENTAL")
                            )
                          ) {
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ] = t("resource.DATA_IMPORT.PRODUCT");
                          }

                          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                          var typeIsProduct =
                            tmpTableData[i][
                              t("resource.DATA_IMPORT.PROD_TYPE")
                            ].toString() == t("resource.DATA_IMPORT.PRODUCT");

                          // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑

                          //行データ
                          let lineData = {
                            didQuoteNo:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.QUOTE_NO")
                              ],
                            didCusCode: didCusCode,
                            managerList: managerList,
                            // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
                            // 得意先担当者が空を表示し、関連チェックを削除する
                            // didCusUserCode: didCusUserCode,
                            didCusUserCode: "",
                            // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
                            didAcceptDate: formatDateStrToyyyyMMdd(
                              new Date(
                                new Date(1900, 0, 1).getTime() +
                                  (Number(
                                    tmpTableData[i][
                                      t("resource.DATA_IMPORT.ACCEPT_DATE")
                                    ]
                                  ) -
                                    1) *
                                    24 *
                                    60 *
                                    60 *
                                    1000
                              )
                            ),
                            didCusDeliveryDate: formatDateStrToyyyyMMdd(
                              new Date(
                                new Date(1900, 0, 1).getTime() +
                                  (Number(
                                    tmpTableData[i][
                                      t(
                                        "resource.DATA_IMPORT.CUS_DELIVERY_DATE"
                                      )
                                    ]
                                  ) -
                                    1) *
                                    24 *
                                    60 *
                                    60 *
                                    1000
                              )
                            ),
                            didCusOrderNo:
                              // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
                              // tmpTableData[i][
                              //   t("resource.DATA_IMPORT.CUS_ORDER_NO")
                              // ],
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.BASIC_INFO") +
                                  STR_UNDERLINE +
                                  t("resource.DATA_IMPORT.CUS_ORDER_NO")
                              ],
                            // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
                            didType:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_TYPE")
                              ],

                            didProdDrawNo:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_DRAW_NO")
                              ],
                            didProdName:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_NAME")
                              ],
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                            // 一式データの場合、数量が1の変更
                            // didProdQuantity:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.PROD_QUANTITY")
                            //   ],
                            didProdQuantity:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_UNIT")
                              ] === UNIT_SET
                                ? STR_ONE
                                : tmpTableData[i][
                                    t("resource.DATA_IMPORT.PROD_QUANTITY")
                                  ],
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                            didProdUnit:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_UNIT")
                              ],
                            // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
                            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
                            // 形状の追加
                            // didProdShape:
                            //   tmpTableData[i][t("resource.DATA_IMPORT.PROD_SHAPE")],
                            didProdShape:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_SHAPE")
                              ],
                            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
                            // didProdMaterial:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.PROD_MATERIAL")
                            //   ],
                            // didProdTreatment:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.PROD_TREATMENT")
                            //   ],
                            // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑

                            didUWeight: typeIsProduct
                              ? tmpTableData[i][
                                  t("resource.DATA_IMPORT.U_WEIGHT")
                                ]
                              : 0,

                            didMSupCode: this.supplierList.find(
                              (it) =>
                                it.supAbbreviation ===
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.SUPPLIER")
                                ]
                            )?.supCode,

                            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
                            // ミスミ関連区分
                            didMisumiKbn: this.misumiKbnList.find(
                              (it) => it.label === misumiKbnLabel
                            )?.value,
                            // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

                            didMSupFactoryKbn: this.supplierList.find(
                              (it) =>
                                it.supAbbreviation ===
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.SUPPLIER")
                                ]
                            )?.supFactoryKbn,
                            didMSupFactoryKbnStr: "",
                            didMCurType: "",
                            didMExr:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.EXCHANGE_RATE")
                              ],
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                            // didMUPriceJpy:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.U_PRICE_JPY")
                            //   ],
                            // didMUPriceCny:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.U_PRICE_CNY")
                            //   ],
                            didMUPriceJpy:
                              setDataFlg &&
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_UNIT")
                              ] !== UNIT_SET
                                ? STR_ZERO
                                : tmpTableData[i][
                                    t("resource.DATA_IMPORT.U_PRICE_JPY")
                                  ],
                            didMUPriceCny:
                              setDataFlg &&
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_UNIT")
                              ] !== UNIT_SET
                                ? STR_ZERO
                                : tmpTableData[i][
                                    t("resource.DATA_IMPORT.U_PRICE_CNY")
                                  ],
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                            // didMUTransportCostCny: typeIsProduct
                            //   ? tmpTableData[i][
                            //     t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY")
                            //     ]
                            //   : 0,
                            didMUTransportCostCny:
                              typeIsProduct &&
                              !(
                                setDataFlg &&
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.PROD_UNIT")
                                ] !== UNIT_SET
                              )
                                ? tmpTableData[i][
                                    t(
                                      "resource.DATA_IMPORT.U_TRANSPORT_COST_CNY"
                                    )
                                  ]
                                : 0,
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                            // UPD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓
                            // didMCommissionRate: typeIsProduct
                            //   ? tmpTableData[i][
                            //       t("resource.DATA_IMPORT.COMMISSION_RATE")
                            //     ]
                            //   : 0,
                            didMCommissionRate: typeIsProduct
                              ? this.checkIsNull(
                                  tmpTableData[i][
                                    t("resource.DATA_IMPORT.COMMISSION_RATE")
                                  ]
                                )
                                ? this.commissionRate
                                : tmpTableData[i][
                                    t("resource.DATA_IMPORT.COMMISSION_RATE")
                                  ]
                              : 0,
                            // UPD 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑

                            didMUPurchasePriceJpy:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.U_PURCHASE_PRICE_JPY")
                              ],
                            didMUPurchasePriceCny:
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.U_PURCHASE_PRICE_CNY")
                              ],

                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP1SupCode: typeIsProduct
                            didP1SupCode: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                this.supplierList
                                  .filter((item) => item.supFactoryKbn !== "1")
                                  .find(
                                    (it) =>
                                      it.supAbbreviation ===
                                      tmpTableData[i][
                                        t("resource.DATA_IMPORT.P1_SUPPLIER")
                                      ]
                                  )?.supCode
                              : "",
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP1SupFactoryKbn: typeIsProduct
                            didP1SupFactoryKbn: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                this.supplierList.find(
                                  (it) =>
                                    it.supAbbreviation ===
                                    tmpTableData[i][
                                      t("resource.DATA_IMPORT.P1_SUPPLIER")
                                    ]
                                )?.supFactoryKbn
                              : "",
                            didP1SupFactoryKbnStr: "",
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP1UPrice: typeIsProduct
                            didP1UPrice: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                                setDataFlg &&
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.PROD_UNIT")
                                ] !== UNIT_SET
                                ? STR_ZERO
                                : // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                                  tmpTableData[i][
                                    t("resource.DATA_IMPORT.P1_U_PRICE")
                                  ]
                              : "",

                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP2SupCode: typeIsProduct
                            didP2SupCode: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                this.supplierList
                                  .filter((item) => item.supFactoryKbn !== "1")
                                  .find(
                                    (it) =>
                                      it.supAbbreviation ===
                                      tmpTableData[i][
                                        t("resource.DATA_IMPORT.P2_SUPPLIER")
                                      ]
                                  )?.supCode
                              : "",
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP2SupFactoryKbn: typeIsProduct
                            didP2SupFactoryKbn: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                this.supplierList.find(
                                  (it) =>
                                    it.supAbbreviation ===
                                    tmpTableData[i][
                                      t("resource.DATA_IMPORT.P2_SUPPLIER")
                                    ]
                                )?.supFactoryKbn
                              : "",
                            didP2SupFactoryKbnStr: "",
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP2UPrice: typeIsProduct
                            didP2UPrice: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                                setDataFlg &&
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.PROD_UNIT")
                                ] !== UNIT_SET
                                ? STR_ZERO
                                : // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                                  tmpTableData[i][
                                    t("resource.DATA_IMPORT.P2_U_PRICE")
                                  ]
                              : "",

                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP3SupCode: typeIsProduct
                            didP3SupCode: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                this.supplierList
                                  .filter((item) => item.supFactoryKbn !== "1")
                                  .find(
                                    (it) =>
                                      it.supAbbreviation ===
                                      tmpTableData[i][
                                        t("resource.DATA_IMPORT.P3_SUPPLIER")
                                      ]
                                  )?.supCode
                              : "",
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP3SupFactoryKbn: typeIsProduct
                            didP3SupFactoryKbn: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                this.supplierList.find(
                                  (it) =>
                                    it.supAbbreviation ===
                                    tmpTableData[i][
                                      t("resource.DATA_IMPORT.P3_SUPPLIER")
                                    ]
                                )?.supFactoryKbn
                              : "",
                            didP3SupFactoryKbnStr: "",
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didP3UPrice: typeIsProduct
                            didP3UPrice: procShowKbn
                              ? // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                                // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                                setDataFlg &&
                                tmpTableData[i][
                                  t("resource.DATA_IMPORT.PROD_UNIT")
                                ] !== UNIT_SET
                                ? STR_ZERO
                                : // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                                  tmpTableData[i][
                                    t("resource.DATA_IMPORT.P3_U_PRICE")
                                  ]
                              : "",

                            didGrossMargin: typeIsProduct
                              ? tmpTableData[i][
                                  t("resource.DATA_IMPORT.GROSS_MARGIN")
                                ]
                              : 0,
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
                            // didUSalesPrice:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.U_SALES_PRICE")
                            //   ],
                            // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                            // 売価が非表示の変更
                            // didUSalesPrice: uSalesPriceVal,
                            // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                            // UPD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
                            // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
                            // didUSetPrice:
                            //   tmpTableData[i][
                            //     t("resource.DATA_IMPORT.U_SET_PRICE")
                            //   ],

                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                            // didUSetPrice: uSetPriceVal,
                            didUSetPrice:
                              setDataFlg &&
                              tmpTableData[i][
                                t("resource.DATA_IMPORT.PROD_UNIT")
                              ] !== UNIT_SET
                                ? STR_ZERO
                                : uSetPriceVal,
                            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                            // UPD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
                          };
                          fileJsonData.push(lineData);
                        }

                        //受注データ取込テーブル
                        this.dataImportTable = fileJsonData.sort((a, b) => {
                          return a.didQuoteNo.localeCompare(b.didQuoteNo);
                        });

                        this.dataProcess();
                        this.tempSaveClick();
                      })
                      .catch((err) => {
                        if (err.data != null) {
                          Message.showError(
                            t(
                              "message.COMMON_MESSAGE." +
                                err.data.Messages[0].Message
                            )
                          );
                        } else {
                          Message.showError(
                            t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
                          );
                        }
                      })
                      .finally(() => {
                        this.showFlag = false;
                      });
                  } else {
                    Modal.showWarning(
                      "",
                      t("message.DATA_IMPORT.FILE_OUTPUT_SUCCESS"),
                      {
                        confirmButtonText: t(
                          "resource.COMMON_CONSTANT.CONFIRM"
                        ),
                      }
                    ).then(() => {
                      //「取込異常情報_20241219_114710.txt」を出力する
                      var fileName = "取込異常情報";
                      outputTxt(
                        fileName +
                          "_" +
                          formatSystemTimeToyyyyMMddHHmmss(
                            new Date(),
                            "yyyyMMdd_HHmmss"
                          ),
                        msg
                      )
                        .then(() => {
                          Message.showSuccess(
                            t("message.COMMON_MESSAGE.OUTPUT_SUCCESS")
                          );
                        })
                        .catch((err) => {
                          Message.showError(
                            t("message.COMMON_MESSAGE.OUTPUT_FAILURE")
                          );
                        })
                        .finally(() => {
                          this.showFlag = false;
                        });
                    });
                  }
                });
            } else {
              this.showWarningMessage(t("message.DATA_IMPORT.FILE_NOT_FORMAT"));
            }
          })
          .catch(() => {
            this.showFlag = false;
            this.showWarningMessage(t("message.DATA_IMPORT.FILE_NOT_FORMAT"));
            return;
          });
      });

      input.click();

      // フォーカス削除
      this.$refs.dataImportBtn.$el.blur();
      this.showFlag = false;
    },

    //受注データ読み取り
    readDataFromXLSX(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // const sheetName = workbook.SheetNames[0]; //最初のsheetページの名前
          // // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // // シート名の変更：「取込フォーマット」⇒「ImportFormat」
          // // if (sheetName != "取込フォーマット") {
          //   if (sheetName != "ImportFormat") {
          //     // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          const sheetName = "ImportFormat"; //最初のsheetページの名前
          // sheetの名のチェック
          const hasImportFormat = workbook.SheetNames.includes(sheetName);
          // シート「ImportFormat」が存在しない場合
          if (!hasImportFormat) {
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            reject();
            return;
          }
          const sheet = workbook.Sheets[sheetName];

          // const jsonDataWithHeader = XLSX.utils.sheet_to_json(sheet, {
          //   header: 1,
          // });

          // // 空白行を削除する
          // const filteredData = jsonDataWithHeader.filter((row) => {
          //   return row.some(
          //     (cell) => cell != null && cell.toString().trim() !== ""
          //   );
          // });

          //シート全体をJSONオブジェクト配列に変換する
          const allData = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
            defval: "",
          });

          // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
          // if (
          //   allData[0][0] == undefined ||
          //   allData[0][0].toString() != t("resource.DATA_IMPORT.BASIC_INFO")
          // ) {
          //   reject();
          //   return;
          // }

          if (
            allData[0][0] == undefined ||
            allData[0][0].toString() != t("resource.DATA_IMPORT.PRODUCT_INFO")
          ) {
            reject();
            return;
          }
          // UPD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

          var preHeader;
          //表のヘッダーをキー値として統合する
          const headers = allData[0].map((header, index) => {
            //現在のheaderが空白の場合、前のheaderを使用してください
            if (header.trim() === "") {
              header = preHeader;
            }
            preHeader = header;

            //表のヘッダーを統合する必要はありません、キーはユニークです
            if (
              header.trim() == "基本情報" ||
              header.trim() == "製品情報" ||
              header.trim() == "加工" ||
              header.trim() == "見積情報"
            ) {
              return `${allData[1][index]}`;
            } else {
              //処理1_加工単価
              return `${header}_${allData[1][index]}`;
            }
          });

          // 第三行からデータを取得
          const excelData = allData.slice(1);

          // 空白行を削除する
          const filteredData = excelData
            .filter((row) => {
              // 行が空をチェックする
              if (row.every((cell) => cell === "")) {
                return false;
              }
              // データと表題を1つのオブジェクトに統合する
              const dataObject = headers.reduce((obj, header, index) => {
                obj[header] = row[index];
                return obj;
              }, {});
              return true;
            })
            .map((row) => {
              // マージ後のオブジェクトを戻る
              return headers.reduce((obj, header, index) => {
                obj[header] = row[index];
                return obj;
              }, {});
            });
          resolve(filteredData);
        };
        reader.readAsArrayBuffer(file);
      });
    },

    //取込の受注データのチェック
    // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
    // importCheck(data) {
    importCheck(data, customerForUserList) {
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
      var msg = "";
      var startRow = 3;

      //省略字
      var contraction = this.getContraction(
        this.dataImportEditForm.dibUserCode
      );

      //見積タイプ
      var type;

      data.forEach((row, index) => {
        //見積タイプ
        if (
          !this.isEmptyOrNull(row[t("resource.DATA_IMPORT.PROD_TYPE")]) &&
          (row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
            t("resource.DATA_IMPORT.PRODUCT") ||
            row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
              t("resource.DATA_IMPORT.DESIGN") ||
            row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
              t("resource.DATA_IMPORT.SUPPLEMENTAL"))
        ) {
          type = row[t("resource.DATA_IMPORT.PROD_TYPE")];
        }
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
        // ミスミの場合、ミスミ見積タイプが製品を表示する
        else if (
          !this.isEmptyOrNull(row[t("resource.DATA_IMPORT.PROD_TYPE")]) &&
          (row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
            t("resource.DATA_IMPORT.MSM_PURCHASED") ||
            row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
              t("resource.DATA_IMPORT.MSM_ASSEMBLY") ||
            row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
              t("resource.DATA_IMPORT.MSM_IN_CMP_ASSEMBLY") ||
            row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
              t("resource.DATA_IMPORT.MSM_IN_CMP_PROCESSING") ||
            row[t("resource.DATA_IMPORT.PROD_TYPE")] ==
              t("resource.DATA_IMPORT.MSM_DL"))
        ) {
          type = row[t("resource.DATA_IMPORT.PROD_TYPE")];
        }
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
        else {
          type = t("resource.DATA_IMPORT.PRODUCT");
        }

        config.checks.forEach((check) => {
          // //タイプが「設計」または「金額調整」の場合、チェックしない
          // if (
          //   type == t("resource.DATA_IMPORT.DESIGN")
          // ) {
          //   if (
          //     check.field == t("resource.DATA_IMPORT.PROD_DRAW_NO") ||
          //     check.field == t("resource.DATA_IMPORT.PROD_NAME") ||
          //     check.field == t("resource.DATA_IMPORT.PROD_QUANTITY") ||
          //     check.field == t("resource.DATA_IMPORT.PROD_UNIT") ||
          //     check.field == t("resource.DATA_IMPORT.PROD_SHAPE") ||
          //     check.field == t("resource.DATA_IMPORT.PROD_MATERIAL") ||
          //     check.field == t("resource.DATA_IMPORT.PROD_TREATMENT") ||
          //     check.field == t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY") ||
          //     check.field == t("resource.DATA_IMPORT.COMMISSION_RATE") ||
          //     check.field == t("resource.DATA_IMPORT.P1_U_PRICE") ||
          //     check.field == t("resource.DATA_IMPORT.P2_U_PRICE") ||
          //     check.field == t("resource.DATA_IMPORT.P3_U_PRICE")
          //   ) {
          //     return;
          //   }
          // }

          //書式ルールのチェック&&必須入力
          if (
            // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
            //check.field == t("resource.DATA_IMPORT.QUOTE_NO") ||
            // FRL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑
            check.field == t("resource.DATA_IMPORT.PROD_UNIT")
          ) {
            //書式が間違っている
            if (!RegExp(check.regex).test(row[check.field])) {
              msg =
                msg +
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // check.regexErrMsg.replace("{0}", Number(startRow + index));
                check.regexErrMsg
                  .replace("{0}", Number(row.rowIndex))
                  .replace("{1}", row[check.field]);
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            }
          }
          // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
          //見積No.の省略字のチェック:書式&&必須入力と受注担当者省略字
          if (check.field == t("resource.DATA_IMPORT.QUOTE_NO")) {
            var quoteNoArr = row[check.field].toString().split("-");
            //書式が間違っている または　担当者省略字が存在しない
            // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
            // 受注担当者の省略字が存在しない場合、エラーメッセージの変更
            // 「行番号「N」の「見積No.」には、受注担当者の省略字が存在しません」
            // if (
            //   !RegExp(check.regex).test(row[check.field]) ||
            //   (quoteNoArr.length > 0 && !this.isContractionExist(quoteNoArr[0]))
            // ) {
            if (!RegExp(check.regex).test(row[check.field])) {
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
              msg =
                msg +
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // check.regexErrMsg.replace("{0}", Number(startRow + index));
                check.regexErrMsg
                  .replace("{0}", Number(row.rowIndex))
                  .replace("{1}", row[check.field]);
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            } else {
              // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // 受注担当者の省略字が存在しない場合、エラーメッセージの変更
              // 「行番号「N」の「見積No.」には、受注担当者の省略字が存在しません」
              if (
                quoteNoArr.length > 0 &&
                !this.isContractionExist(quoteNoArr[0])
              ) {
                msg =
                  msg +
                  t("message.DATA_IMPORT.USER_CONTRACT_NOT_EXIST")
                    .replace("{0}", Number(row.rowIndex))
                    .replace("{1}", row[check.field]);
              } else {
                //「得意先」は「受注担当者」に対応する「得意先」ではない
                var userList = customerForUserList.filter(
                  (x) => x.didCusCode == quoteNoArr[1]
                );

                // 「受注担当者」に対応する得意先ではない
                var exists = userList.some((item) =>
                  item.managerList.some(
                    (m) => m.contraction && m.contraction === quoteNoArr[0]
                  )
                );
                if (!customerForUserList || (userList.length > 0 && !exists)) {
                  msg =
                    msg +
                    t("message.DATA_IMPORT.USER_CUS_CHECK")
                      .replace("{0}", Number(row.rowIndex))
                      .replace("{1}", row[check.field]);
                }
              }
            }
            // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          }
          // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑

          //数量書式のチェック
          if (check.field == t("resource.DATA_IMPORT.PROD_QUANTITY")) {
            if (
              type == t("resource.DATA_IMPORT.PRODUCT") ||
              type == t("resource.DATA_IMPORT.DESIGN")
            ) {
              //書式が間違っている(製品/設計:1~99999)
              if (!RegExp(check.regex1_99999).test(row[check.field])) {
                msg =
                  msg +
                  check.regexErrMsg1_99999
                    .replace(
                      "{0}",
                      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                      // Number(startRow + index)
                      Number(row.rowIndex)
                      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                    )
                    .replace("{1}", row[check.field]);
              }
            } else {
              //書式が間違っている(金額調整:-99999~99999)
              if (!RegExp(check.regex99999_99999).test(row[check.field])) {
                msg =
                  msg +
                  check.regexErrMsg99999_99999
                    .replace(
                      "{0}",
                      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                      // Number(startRow + index)
                      Number(row.rowIndex)
                      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
                    )
                    .replace("{1}", row[check.field]);
              }
            }
          }

          //日付書式のチェック：YYYY/MM/DD
          if (
            check.field == t("resource.DATA_IMPORT.ACCEPT_DATE") ||
            check.field == t("resource.DATA_IMPORT.CUS_DELIVERY_DATE")
          ) {
            //書式が間違っている
            if (
              this.isEmptyOrNull(row[check.field]) ||
              !RegExp(check.regex).test(
                formatDateToString(
                  new Date(
                    new Date(1900, 0, 1).getTime() +
                      row[check.field] * 24 * 60 * 60 * 1000
                  )
                )
              )
            ) {
              msg =
                msg +
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // check.regexErrMsg.replace("{0}", Number(startRow + index));
                check.regexErrMsg
                  .replace("{0}", Number(row.rowIndex))
                  .replace("{1}", row[check.field]);
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            }
          }

          //書式ルールのチェック&&非必須入力
          if (
            check.field == t("resource.DATA_IMPORT.U_WEIGHT") ||
            check.field == t("resource.DATA_IMPORT.EXCHANGE_RATE") ||
            check.field == t("resource.DATA_IMPORT.U_PRICE_JPY") ||
            check.field == t("resource.DATA_IMPORT.U_PRICE_CNY") ||
            check.field == t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY") ||
            check.field == t("resource.DATA_IMPORT.COMMISSION_RATE") ||
            // check.field == t("resource.DATA_IMPORT.U_PURCHASE_PRICE_JPY") ||
            // check.field == t("resource.DATA_IMPORT.U_PURCHASE_PRICE_CNY") ||
            check.field == t("resource.DATA_IMPORT.P1_U_PRICE") ||
            check.field == t("resource.DATA_IMPORT.P2_U_PRICE") ||
            check.field == t("resource.DATA_IMPORT.P3_U_PRICE") ||
            check.field == t("resource.DATA_IMPORT.GROSS_MARGIN") ||
            check.field == t("resource.DATA_IMPORT.U_SALES_PRICE") ||
            check.field == t("resource.DATA_IMPORT.U_SET_PRICE")
          ) {
            //書式が間違っている
            if (
              !this.isEmptyOrNull(row[check.field]) &&
              !RegExp(check.regex).test(row[check.field])
            ) {
              msg =
                msg +
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // check.regexErrMsg.replace("{0}", Number(startRow + index));
                check.regexErrMsg
                  .replace("{0}", Number(row.rowIndex))
                  .replace("{1}", row[check.field]);
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            }
          }

          // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
          // if (check.field == t("resource.DATA_IMPORT.QUOTE_NO")) {
          //   var quoteNoArr = row[check.field].toString().split("-");
          //   //見積No.の省略字が間違っている
          //   if (quoteNoArr.length > 0 && quoteNoArr[0] != contraction) {
          //     msg =
          //       msg +
          //       t("message.DATA_IMPORT.QUOTE_NO_USER_DIFFERENT").replace(
          //         "{0}",
          //         Number(startRow + index)
          //       );
          //   }
          // }
          // DEL 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑

          //最大入力桁数のチェック
          if (
            check.field == t("resource.DATA_IMPORT.CUS_INFO_ORDER_NO") ||
            check.field == t("resource.DATA_IMPORT.PROD_DRAW_NO") ||
            check.field == t("resource.DATA_IMPORT.PROD_NAME") ||
            // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい start↓
            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
            // 形状の追加
            // ||
            // check.field == t("resource.DATA_IMPORT.PROD_SHAPE") ||
            check.field == t("resource.DATA_IMPORT.PROD_SHAPE")
            // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
            // check.field == t("resource.DATA_IMPORT.PROD_MATERIAL") ||
            // check.field == t("resource.DATA_IMPORT.PROD_TREATMENT")
            // DEL 2025/03/19 ZLL 課題_形状、素材、処理を削除したい end↑
          ) {
            if (
              !this.isEmptyOrNull(row[check.field]) &&
              (String(row[check.field]).length > check.maxLength ||
                String(row[check.field]).indexOf("e+") != -1)
            ) {
              msg =
                msg +
                // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
                // check.maxLengthErrMsg.replace("{0}", Number(startRow + index));
                check.maxLengthErrMsg
                  .replace("{0}", Number(row.rowIndex))
                  .replace("{1}", row[check.field]);
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
            }
          }
        });

        //(製品の場合)「図番」と「品名」には少なくとも1つの値がある
        //if (type == t("resource.DATA_IMPORT.PRODUCT")) {
        if (
          this.isEmptyOrNull(row[t("resource.DATA_IMPORT.PROD_DRAW_NO")]) &&
          this.isEmptyOrNull(row[t("resource.DATA_IMPORT.PROD_NAME")])
        ) {
          msg =
            msg +
            t("message.DATA_IMPORT.DATA_ERROR")
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
              // .replace("{0}", Number(startRow + index))
              .replace("{0}", Number(row.rowIndex))
              // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
              .replace("{1}", t("resource.DATA_IMPORT.PROD_DRAW_NO"))
              .replace("は", "または")
              .replace("{2}", t("resource.DATA_IMPORT.PROD_NAME"));
        }
        //}
      });

      /*//フォーマットと入力が必要かどうかのチェック
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
          //見積タイプ
          var type = data[i][6];

          //見積No.のチェック：S-123-12345
          if (j == 0) {
            reg = /^[A-Z]-\d{3}-\d{5}$/;
            if (!reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.QUOTE_NO"))
                  .replace("{2}", "英数字、-");
            }

            var quoteNoArr = data[i][j].toString().split("-");
            //見積No.の省略字が間違っている
            if (quoteNoArr.length > 0 && quoteNoArr[0] != contraction) {
              msg =
                msg +
                t("message.DATA_IMPORT.QUOTE_NO_USER_DIFFERENT").replace(
                  "{0}",
                  Number(startRow + i)
                );
            }
          } else if (j == 3) {
            //受注日のチェック：YYYY/MM/DD
            reg = /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
            if (
              !reg.test(
                formatDateToString(
                  new Date(
                    new Date(1900, 0, 1).getTime() +
                      data[i][j] * 24 * 60 * 60 * 1000
                  )
                )
              )
            ) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.ACCEPT_DATE"))
                  .replace("{2}", "日付");
            }
          } else if (j == 4) {
            //納期のチェック：YYYY/MM/DD
            reg = /^(\d{4})\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
            if (
              !reg.test(
                formatDateToString(
                  new Date(
                    new Date(1900, 0, 1).getTime() +
                      data[i][j] * 24 * 60 * 60 * 1000
                  )
                )
              )
            ) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"))
                  .replace("{2}", "日付");
            }
          } else if (j == 5) {
            //注番のチェック：最大入力桁数20
            if (!this.isEmptyOrNull(data[i][j]) && data[i][j].length > 20) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.CUS_ORDER_NO"))
                  .replace("{2}", "20桁以内");
            }
          } else if (j == 7 || j == 8) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「図番、品名」をチェックしない
              continue;
            }
            if (j == 8) {
              continue;
            }

            //「図番」と「品名」には少なくとも1つの値がある
            if (
              this.isEmptyOrNull(data[i][7]) &&
              this.isEmptyOrNull(data[i][8])
            ) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.PROD_DRAW_NO"))
                  .replace("は", "または")
                  .replace("{2}", t("resource.DATA_IMPORT.PROD_NAME"));
            } else {
              //図番のチェック：最大入力桁数30
              if (!this.isEmptyOrNull(data[i][7]) && data[i][7].length > 30) {
                msg =
                  msg +
                  t("message.DATA_IMPORT.DATA_ERROR")
                    .replace("{0}", Number(startRow + i))
                    .replace("{1}", t("resource.DATA_IMPORT.PROD_DRAW_NO"))
                    .replace("{2}", "30桁以内");
              }

              //品名のチェック：最大入力桁数20
              if (!this.isEmptyOrNull(data[i][8]) && data[i][8].length > 20) {
                msg =
                  msg +
                  t("message.DATA_IMPORT.DATA_ERROR")
                    .replace("{0}", Number(startRow + i))
                    .replace("{1}", t("resource.DATA_IMPORT.PROD_NAME"))
                    .replace("{2}", "20桁以内");
              }
            }
          } else if (j == 9) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「数量」をチェックしない
              continue;
            }
            //数量のチェック：0～99999
            reg = /^[1-9]\d{0,4}|0$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.PROD_QUANTITY"))
                  .replace("{2}", "0～99999");
            }
          } else if (j == 10) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「単位」をチェックしない
              continue;
            }
            //単位のチェック：個/式
            if (
              data[i][j] != "個" &&
              data[i][j] != "式" &&
              data[i][j] != STR_EMPTY
            ) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.PROD_UNIT"))
                  .replace("{2}", "個または式またはブランク");
            }
          } else if (j == 11) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「形状」をチェックしない
              continue;
            }
            //形状のチェック：最大入力桁数20
            if (!this.isEmptyOrNull(data[i][j]) && data[i][j].length > 20) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.PROD_SHAPE"))
                  .replace("{2}", "20桁以内");
            }
          } else if (j == 11) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「素材」をチェックしない
              continue;
            }
            //素材のチェック：最大入力桁数50
            if (!this.isEmptyOrNull(data[i][j]) && data[i][j].length > 50) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.PROD_MATERIAL"))
                  .replace("{2}", "50桁以内");
            }
          } else if (j == 13) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「処理」をチェックしない
              continue;
            }

            //処理のチェック：最大入力桁数50
            if (!this.isEmptyOrNull(data[i][j]) && data[i][j].length > 50) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.PROD_TREATMENT"))
                  .replace("{2}", "50桁以内");
            }
          } else if (j == 14) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「処理」をチェックしない
              continue;
            }
            //重量のチェック：0～999.999
            reg = /^(0(\.\d{1,3})?|[1-9]\d{0,2}(\.\d{1,3})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.U_WEIGHT"))
                  .replace("{2}", "0～999.999");
            }
          } else if (j == 16) {
            //レートのチェック：0～999.99
            reg = /^(0(\.\d{1,2})?|[1-9]\d{0,2}(\.\d{1,2})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.EXCHANGE_RATE")
                  )
                  .replace("{2}", "0～999.99");
            }
          } else if (j == 17) {
            //加工単価(JPY)のチェック：0～99999999
            reg = /^(0|[1-9]\d{0,7})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PRICE_JPY")
                  )
                  .replace("{2}", "0～99999999");
            }
          } else if (j == 18) {
            //加工単価(CNY)のチェック：0～99999.99
            reg = /^(0(\.\d{1,2})?|[1-9]\d{0,4}(\.\d{1,2})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PRICE_CNY")
                  )
                  .replace("{2}", "0～99999.99");
            }
          } else if (j == 19) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「運賃(CNY)」をチェックしない
              continue;
            }

            //運賃(CNY)のチェック：0～99999.99
            reg = /^(0(\.\d{1,2})?|[1-9]\d{0,4}(\.\d{1,2})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.U_TRANSPORT_COST_CNY")
                  )
                  .replace("{2}", "0～99999.99");
            }
          } else if (j == 20) {
            if (type == "設計") {
              //タイプが「設計」の場合は、「提成率」をチェックしない
              continue;
            }
            //提成率(%)のチェック：0～99.99
            reg = /^(0(\.\d{1,2})?|[1-9]\d{0,1}(\.\d{1,2})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.COMMISSION_RATE")
                  )
                  .replace("{2}", "0～99.99");
            }
          } else if (j == 21) {
            //加工仕入価格(JPY)のチェック：0～999999999
            reg = /^(0|[1-9]\d{0,8})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PURCHASE_PRICE_JPY")
                  )
                  .replace("{2}", "0～999999999");
            }
          } else if (j == 22) {
            //加工仕入価格(CNY)のチェック：0～999999.99
            reg = /^(0(\.\d{1,2})?|[1-9]\d{0,5}(\.\d{1,2})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.MAIN_PROCESSING") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PURCHASE_PRICE_CNY")
                  )
                  .replace("{2}", "0～99999.99");
            }
          } else if (j == 24) {
            //処理1加工単価のチェック：0～99999999
            reg = /^(0|[1-9]\d{0,7})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.PROCESSING_ONE") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PRICE")
                  )
                  .replace("{2}", "0～99999999");
            }
          } else if (j == 26) {
            //処理2加工単価のチェック：0～99999999
            reg = /^(0|[1-9]\d{0,7})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.PROCESSING_TWO") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PRICE")
                  )
                  .replace("{2}", "0～99999999");
            }
          } else if (j == 28) {
            //処理3加工単価のチェック：0～99999999
            reg = /^(0|[1-9]\d{0,7})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace(
                    "{1}",
                    t("resource.DATA_IMPORT.PROCESSING_THREE") +
                      "_" +
                      t("resource.DATA_IMPORT.U_PRICE")
                  )
                  .replace("{2}", "0～99999999");
            }
          } else if (j == 29) {
            //粗利率(%)のチェック：0～99.99
            reg = /^(0(\.\d{1,2})?|[1-9]\d{0,1}(\.\d{1,2})?)$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.GROSS_MARGIN"))
                  .replace("{2}", "0～99.99");
            }
          } else if (j == 30) {
            //売価のチェック：0～99999999999
            reg = /^(0|[1-9]\d{0,10})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.U_SALES_PRICE"))
                  .replace("{2}", "0～99999999999");
            }
          } else if (j == 31) {
            //確定売価のチェック：0～99999999999
            reg = /^(0|[1-9]\d{0,10})$/;
            if (!this.isEmptyOrNull(data[i][j]) && !reg.test(data[i][j])) {
              msg =
                msg +
                t("message.DATA_IMPORT.DATA_ERROR")
                  .replace("{0}", Number(startRow + i))
                  .replace("{1}", t("resource.DATA_IMPORT.U_SET_PRICE"))
                  .replace("{2}", "0～99999999999");
            }
          }
        }
      }*/

      //同見積No.の基本情報一致のチェック
      //[{aa1,bb1,cc1},{aa2,bb2,cc2}]⇒[{"1":"aa1","2":"bb1","3":"cc1"},{"1":"aa2","2":"bb2","3":"cc2"}]
      let jsonArray = [];
      for (let i = 0; i < data.length; i++) {
        let obj = {
          quoteNo: data[i][t("resource.DATA_IMPORT.QUOTE_NO")],
          acceptDate: data[i][t("resource.DATA_IMPORT.ACCEPT_DATE")],
          cusDeliveryDate: data[i][t("resource.DATA_IMPORT.CUS_DELIVERY_DATE")],
        };
        jsonArray.push(obj);
      }

      //[{"1":"aa1","2":"bb1","3":"cc1"},{"1":"aa2","2":"bb2","3":"cc2"}]⇒[{"1":[aa1,aa2]},{"2":[bb1,bb2]},{"3":[cc1,cc2]}]
      const acceptDateMap = new Map();
      const cusDeliveryDateMap = new Map();

      jsonArray.forEach((obj) => {
        const { quoteNo, acceptDate, cusDeliveryDate } = obj;
        if (acceptDateMap.has(quoteNo)) {
          acceptDateMap.get(quoteNo).push(acceptDate);
          cusDeliveryDateMap.get(quoteNo).push(cusDeliveryDate);
        } else {
          acceptDateMap.set(quoteNo, [acceptDate]);
          cusDeliveryDateMap.set(quoteNo, [cusDeliveryDate]);
        }
      });

      //受注日が一致しない場合
      acceptDateMap.forEach((acceptDateArr, quoteNo) => {
        const uniqueAcceptDates = [...new Set(acceptDateArr)];
        if (uniqueAcceptDates.length > 1) {
          msg =
            msg +
            t("message.DATA_IMPORT.DIFFERENT_BASIC_INFO")
              .replace("{0}", quoteNo)
              .replace("{1}", t("resource.DATA_IMPORT.ACCEPT_DATE"));
        }
      });

      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
      // 納期、注番の変更(見積単位⇒製品単位に変更)
      // //納期が一致しない場合
      // cusDeliveryDateMap.forEach((cusDeliveryDateArr, quoteNo) => {
      //   const uniqueCusDeliveryDates = [...new Set(cusDeliveryDateArr)];
      //   if (uniqueCusDeliveryDates.length > 1) {
      //     msg =
      //       msg +
      //       t("message.DATA_IMPORT.DIFFERENT_BASIC_INFO")
      //         .replace("{0}", quoteNo)
      //         .replace("{1}", t("resource.DATA_IMPORT.CUS_DELIVERY_DATE"));
      //   }
      // });
      // DEL 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

      //見積タイプ一致のチェック
      const typeList = [];
      for (let x = 0; x < data.length; x++) {
        var type = data[x][t("resource.DATA_IMPORT.PROD_TYPE")].toString();
        if (typeList.indexOf(type) == -1) {
          typeList.push(type);
        }
      }
      if (
        typeList.indexOf(t("resource.DATA_IMPORT.SUPPLEMENTAL")) != -1 &&
        typeList.length > 1
      ) {
        msg = msg + t("message.DATA_IMPORT.TYPE_NOT_ALL_SUPPLEMENTAL");
      }

      // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
      // // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // // 一式機能機能の追加
      // // 一式データのサイズの取得
      // const unitCount = data.filter(
      //   (row) =>
      //     row[t("resource.DATA_IMPORT.PROD_UNIT")]?.toString() === UNIT_SET
      // ).length;

      // // 一式データの場合、「単位」が「式」の製品が複数の場合、メッセージを追加
      // if (unitCount > NUM_ONE) {
      //   msg = msg + t("message.DATA_IMPORT.A_SET_UNIT_CHECK");
      // }

      // // 一式データの場合、見積NO.が複数の場合、メッセージの追加
      // if (unitCount == NUM_ONE) {
      //   const quoteNoCount = new Set(
      //     data
      //       .map((row) => row[t("resource.DATA_IMPORT.QUOTE_NO")]?.toString())
      //       .filter(Boolean)
      //   ).size;

      //   if (quoteNoCount > 1) {
      //     msg = msg + t("message.DATA_IMPORT.A_SET_QUOTE_NO_CHECK");
      //   }
      // }
      // // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // 各見積NO.製品の「式」の回数
      const countMap = {};
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      const checkProdType = data.some(
        (item) =>
          item[t("resource.DATA_IMPORT.PROD_TYPE")]?.toString() ===
            t("resource.DATA_IMPORT.DESIGN") ||
          item[t("resource.DATA_IMPORT.PROD_TYPE")]?.toString() ===
            t("resource.DATA_IMPORT.SUPPLEMENTAL")
      );
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      data.forEach((row) => {
        const quoteNo = row[t("resource.DATA_IMPORT.QUOTE_NO")]?.toString();
        const prodUnit = row[t("resource.DATA_IMPORT.PROD_UNIT")]?.toString();
        if (!quoteNo) return;
        if (countMap[quoteNo] === undefined) {
          countMap[quoteNo] = 0;
        }

        if (prodUnit === UNIT_SET) {
          countMap[quoteNo]++;
        }
      });

      // すべての出現した見積NO.
      const allQuoteNos = [
        ...new Set(
          data.map((r) => r[t("resource.DATA_IMPORT.QUOTE_NO")]?.toString())
        ),
      ];

      // 全員の見積NO.の単位が「式」の回数は0回
      const allZero = allQuoteNos.every((q) => !countMap[q]);

      // 全員の見積NO.の単位が「式」の回数は1回
      const allOne = allQuoteNos.every((q) => countMap[q] === 1);

      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      // 金額調整、設計の場合、 一式データを読み込みしない
      if (checkProdType && (allOne || (!allZero && !allOne))) {
        msg = msg + t("message.DATA_IMPORT.A_SET_PROD_TYPE_CHECK");
      } else {
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

        // 一式データの場合、見積NO.の単位が「式」の回数は1回以外の場合、メッセージを追加する
        if (!allZero && !allOne) {
          Object.entries(countMap).forEach(([quoteNo, count]) => {
            // 各見積NO.製品の「単位」が「式」の回数が1回以上の場合、メッセージを追加
            if (count > NUM_ONE) {
              msg =
                msg +
                t("message.DATA_IMPORT.A_SET_UNIT_CHECK").replace(
                  "{0}",
                  quoteNo
                );
            }

            // 各見積NO.製品の「単位」が「式」の回数が0回の場合、メッセージを追加
            if (count == NUM_ZERO) {
              msg =
                msg +
                t("message.DATA_IMPORT.A_SET_UNIT_DATA_CHECK").replace(
                  "{0}",
                  quoteNo
                );
            }
          });
        }
        // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
        // 一式データ、単位が「式」以外の製品の加工単価・確定売価が存在のチェックの追加。
        else if (allOne) {
          const priceFields = [
            "U_PRICE_JPY",
            "U_PRICE_CNY",
            // "U_TRANSPORT_COST_CNY",
            "P1_U_PRICE",
            "P2_U_PRICE",
            "P3_U_PRICE",
            "U_SET_PRICE",
          ].map((key) => t(`resource.DATA_IMPORT.${key}`));

          const hasPrice = (row) =>
            priceFields.some((field) => {
              const val = row[field]?.toString();

              return (
                val && val !== NUM_ZERO && val !== STR_ZERO && val !== STR_EMPTY
              );
            });

          const quoteMap = {};

          data.forEach((row) => {
            const quoteNo = row[t("resource.DATA_IMPORT.QUOTE_NO")]?.toString();
            if (!quoteNo) return;
            quoteMap[quoteNo] ||= [];
            quoteMap[quoteNo].push(row);
          });

          Object.keys(countMap).forEach((quoteNo) => {
            const rows = quoteMap[quoteNo] || [];
            const hasSetUnit = rows.some(
              (r) =>
                r[t("resource.DATA_IMPORT.PROD_UNIT")]?.toString() === UNIT_SET
            );
            if (!hasSetUnit) return;

            const hasNonSetWithPrice = rows.some(
              (r) =>
                r[t("resource.DATA_IMPORT.PROD_UNIT")]?.toString() !==
                  UNIT_SET && hasPrice(r)
            );

            if (hasNonSetWithPrice) {
              msg += t("message.DATA_IMPORT.A_SET_PRICE_CHECK").replace(
                "{0}",
                quoteNo
              );
            }
          });
        }
      }
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      // // 一式データの場合、見積NO.が複数の場合、メッセージの追加
      // if (unitCount == NUM_ONE) {
      //   const quoteNoCount = new Set(
      //     data
      //       .map((row) => row[t("resource.DATA_IMPORT.QUOTE_NO")]?.toString())
      //       .filter(Boolean)
      //   ).size;

      //   if (quoteNoCount > 1) {
      //     msg = msg + t("message.DATA_IMPORT.A_SET_QUOTE_NO_CHECK");
      //   }
      // }

      // UPD 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
      return msg;
    },

    // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 start↓
    //省略字が存在のチェック、true：存在する
    isContractionExist(contraction) {
      return (
        this.userList.find((it) => it.Contraction === contraction) != undefined
      );
    },
    // ADD 2025/2/27 Wjx (#34631)取込フォーマットに見積No.のチェックの変更 end↑

    showWarningMessage(message) {
      Modal.showWarning("", message, {
        confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        onClose: () => {
          this.loading = false;
        },
      }).then(() => {
        this.loading = false;
      });
    },

    //一時保存
    tempSaveClick() {
      this.showFlag = true;
      if (this.localIsAdd) {
        addDataImportDetailByDibNo({
          dataImportBasicInfo: this.dataImportEditForm,
          dataImportDetailInfos: this.tableDataAddProcNo(),
          user: getUserInfo().UserId,
          //  didUpdateTime: this.didUpdateTime,
        })
          .then((res) => {
            this.quoteNoExistFlg = false;
            this.dataImportNo = res;

            Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
            this.numLoads = 1;
            this.localIsAdd = false;
            this.searchDataImportDetailByDibNoProc();
          })
          .catch((err) => {
            this.showFlag = false;
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
              if (err.data.Messages[0].Message == "QUOTE_NO_ALREADY_EXIST") {
                this.quoteNoExistFlg = true;
              }
            } else {
              Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
            }
          });
      } else {
        editDataImportDetailByDibNo({
          didNo: this.dataImportNo,
          dataImportDetailInfos: this.tableDataAddProcNo(),
          user: getUserInfo().UserId,
          didUpdateTime: this.didUpdateTime,
          dataImportAgainFlag: this.dataImportAgainFlag,
          dataImportBasicInfo: this.dataImportEditForm,
        })
          .then((res) => {
            if (this.dataImportAgainFlag) {
              this.dataImportNo = res;
            }
            Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
            this.numLoads = 1;
            this.searchDataImportDetailByDibNoProc();
          })
          .catch((err) => {
            this.showFlag = false;
            if (err.data != null) {
              Message.showError(
                t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
              );
            } else {
              Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
            }
            this.searchDataImportDetailByDibNoProc();
          });
      }
    },

    //テーブルデータの見積明細Noを追加する
    tableDataAddProcNo() {
      var tmpTableData = this.dataImportTable.slice(0);

      //見積明細No
      var prodNo = 0;
      var quoteNo = "";
      var prodNoFlg = false;
      for (var i = 0; i < tmpTableData.length; i++) {
        if (i == 0) {
          quoteNo = tmpTableData[i]["didQuoteNo"];

          prodNoFlg = false;
        } else {
          prodNoFlg = quoteNo == tmpTableData[i]["didQuoteNo"];
          quoteNo = tmpTableData[i]["didQuoteNo"];
        }

        prodNo = prodNoFlg ? prodNo + 1 : 1;

        tmpTableData[i].didProdNo = prodNo;
      }
      return tmpTableData;
    },

    //受注データ作成ボタン
    addAcceptClick() {
      //入力チェック
      if (this.inputCheck()) {
        //同見積No.のレート一致のチェック
        //[{aa1,bb1,cc1},{aa2,bb2,cc2}]⇒[{"1":"aa1","2":"bb1","3":"cc1"},{"1":"aa2","2":"bb2","3":"cc2"}]
        let jsonArray = [];
        for (let i = 0; i < this.dataImportTable.length; i++) {
          let obj = {
            quoteNo: this.dataImportTable[i].didQuoteNo,
            supFactoryKbn: this.dataImportTable[i].didMSupFactoryKbn,
            exr: this.dataImportTable[i].didMExr,
          };
          jsonArray.push(obj);
        }

        //[{"1":"aa1","2":"bb1","3":"cc1"},{"1":"aa2","2":"bb2","3":"cc2"}]⇒[{"1":[aa1,aa2]},{"2":[bb1,bb2]},{"3":[cc1,cc2]}]
        const exrMap = new Map();
        jsonArray.forEach((obj) => {
          const { quoteNo, supFactoryKbn, exr } = obj;

          if (supFactoryKbn == FACTORY_KBN_DALIAN) {
            if (exrMap.has(quoteNo)) {
              exrMap.get(quoteNo).push(exr);
            } else {
              exrMap.set(quoteNo, [exr]);
            }
          }
        });

        var exrFlag = true;
        var tmpQuoteNo;

        exrMap.forEach((exrArr, quoteNo) => {
          const uniqueExrs = [...new Set(exrArr)];
          if (uniqueExrs.length > 1) {
            exrFlag = false;
            tmpQuoteNo = quoteNo;
          }
        });

        //レートが一致しない場合、受注データ作成しない
        if (!exrFlag) {
          Modal.showWarning(
            "",
            t("message.DATA_IMPORT.DIFFERENT_BASIC_INFO_EXR")
              .replace("{0}", tmpQuoteNo)
              .replace("{1}", t("resource.DATA_IMPORT.EXCHANGE_RATE")),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              //「はい」を選択する場合、受注データ作成
              this.addAcceptInfoByDataImportProc();
            })
            .catch(() => {});
        }
        //レートが一致する場合、受注データ作成する
        else {
          this.addAcceptInfoByDataImportProc();
        }
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    //受注データ作成ボタン
    addAcceptInfoByDataImportProc() {
      this.showFlag = true;
      addAcceptInfoByDataImport({
        didNo: this.dataImportNo,
        dataImportDetailInfos: this.tableDataAddProcNo(),
        user: getUserInfo().UserId,
        didUpdateTime: this.didUpdateTime,
        dataImportAgainFlag: this.dataImportAgainFlag,
        dataImportBasicInfo: this.dataImportEditForm,
        //user: getUserInfo().UserId,
      })
        .then((res) => {
          //this.notAcceptedFlg = false;

          Message.showSuccess(t("message.COMMON_MESSAGE.ADD_SUCCESS"));
          this.numLoads = 1;

          this.searchDataImportDetailByDibNoProc();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.ADD_FAILURE"));
          }
          this.searchDataImportDetailByDibNoProc();
        });
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;

      //「受注済み」または「取込担当者・ログインユーザが空」の場合、編集不可
      if (!this.notAcceptedFlg || this.userNullFlag) {
        return "";
      }

      //編集可能な列:
      //「得意先」「得意先担当者」「注番」「重量」
      //「加工_仕入先」「加工_レート」「加工_加工単価(JPY)」「加工_加工単価(CNY)」「加工_運賃(CNY/个)」「加工_提成率（%）」
      //「処理1_仕入先」「処理1_加工単価(JPY)」「処理2_仕入先」「処理2_加工単価(JPY)」「処理3_仕入先」「処理3_加工単価(JPY)」
      //「粗利率(%)」「確定売価」
      var columnEditable = [
        "didCusCode",
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
        // 得意先担当者：変更不可
        // "didCusUserCode",
        // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
        "didCusOrderNo",
        "didUWeight",
        "didMSupCode",
        "didMExr",
        "didMUPriceJpy",
        "didMUPriceCny",
        "didMUTransportCostCny",
        "didMCommissionRate",
        "didP1SupCode",
        "didP1UPrice",
        "didP2SupCode",
        "didP2UPrice",
        "didP3SupCode",
        "didP3UPrice",
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
        // 粗利率(%)が編集不可
        // "didGrossMargin",
        // DEL 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        "didUSetPrice",
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
        "didMUPrice",
        "didUWeightTransCost", // 重量 / 運賃
        "didUSalesPriceSetPrice", // 売価 / 確定売価
        "didCusCodeUserCode", // 得意先
        "didSupFacKbnExr", // 工場 (貨幣) / レート
        // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
        "didMisumiKbn", // ミスミ関連区分
        // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
      ];

      //仕入先が空の場合、加工単価が編集不可
      if (this.isEmptyOrNull(row.didP1SupCode)) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didP1UPrice"
        );
      }
      if (this.isEmptyOrNull(row.didP2SupCode)) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didP2UPrice"
        );
      }
      if (this.isEmptyOrNull(row.didP3SupCode)) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didP3UPrice"
        );
      }
      //見積タイプが「製品」以外の場合、重量と運賃(CNY)と提成率(%)と処理が編集不可
      if (row.didType != t("resource.DATA_IMPORT.PRODUCT")) {
        columnEditable = columnEditable.filter(
          (item) =>
            item !== "didUWeight" &&
            item !== "didMUTransportCostCny" &&
            // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
            item !== "didUWeightTransCost" && // 運賃(CNY)
            // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑
            item !== "didMCommissionRate" &&
            item !== "didP1SupCode" &&
            item !== "didP1UPrice" &&
            item !== "didP2SupCode" &&
            item !== "didP2UPrice" &&
            item !== "didP3SupCode" &&
            item !== "didUSetPrice"
        );
      }
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      var ASetDataFlg = this.dataImportTable.some(
        (row) => row.didProdUnit === UNIT_SET
      );

      if (ASetDataFlg && row.didProdUnit !== UNIT_SET) {
        columnEditable = columnEditable.filter(
          (item) =>
            item !== "didMUPrice" &&
            item !== "didP1UPrice" &&
            item !== "didP2UPrice" &&
            item !== "didP3UPrice" &&
            item !== "didUSalesPriceSetPrice"
        );
      }
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      if (row.didMSupFactoryKbnStr == STR_EMPTY) {
        columnEditable = columnEditable.filter(
          (item) =>
            item !== "didMUPriceJpy" &&
            item !== "didMExr" &&
            item !== "didMUPriceCny" &&
            item !== "didMUTransportCostCny" &&
            item !== "didMCommissionRate"
        );
      } else {
        //加工_仕入先が大連の場合、加工単価(JPY)が編集不可
        if (row.didMSupFactoryKbnStr == STR_DALIAN) {
          columnEditable = columnEditable.filter(
            (item) => item !== "didMUPriceJpy"
          );
        } else {
          //加工_仕入先が大連以外の場合、レート、加工単価(CNY)、運賃(CNY)、提成率(%)が編集不可
          columnEditable = columnEditable.filter(
            (item) =>
              item !== "didMExr" &&
              item !== "didMUPriceCny" &&
              item !== "didMUTransportCostCny" &&
              item !== "didMCommissionRate"
          );
        }
      }

      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
      //ミスミ仕入先以外またはミスミ仕入先&&金額調整の場合、ミスミ関連区分は背景色がない
      if (
        this.isNotMisumiSupplier(row) ||
        this.isMisumiSupplierAndSupplemental(row)
      ) {
        columnEditable = columnEditable.filter(
          (item) => item !== "didMisumiKbn"
        );
      }

      // ミスミ関連区分は「購入品、‐」以外の場合、処理1～3、確定売価は背景色がない
      if (this.misumiKbnIsNotPurchased(row.didMisumiKbn)) {
        columnEditable = columnEditable.filter(
          (item) =>
            item !== "didP1SupCode" &&
            item !== "didP1UPrice" &&
            item !== "didP2SupCode" &&
            item !== "didP2UPrice" &&
            item !== "didP3SupCode" &&
            item !== "didP3UPrice" &&
            item !== "didUSalesPriceSetPrice"
        );
      }
      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

      if (columnEditable.includes(column.property)) {
        //運賃(元/个)の背景色：数量,加工単価(CNY),重量
        // DEL 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 start↓

        // if (column.property == "didMUTransportCostCny") {
        //   if (row.didMSupFactoryKbnStr == STR_DALIAN) {
        //     return this.calDidMUTransportCostCnyColor(
        //       row.didProdQuantity,
        //       formatCurrencyToNumber(row.didMUPriceCny),
        //       row.didUWeight
        //     );
        //   } else {
        //     return "";
        //   }
        // } else {
        // DEL 2025/03/19 ZLL 課題_重量、運賃(CNY)全部通過取込フォーマット直接取込の変更 end↑
        //編集可能の背景色
        return "bg-cell-editable";
        // }
      }
    },

    //担当者の省略字の取得
    getContraction(userCode) {
      for (var i = 0; i < this.userList.length; i++) {
        if (this.userList[i].UserId === userCode) {
          return this.userList[i].Contraction;
        }
      }
    },

    //Enter処理
    focusNextInput(index, columnProp) {
      index = index + 1;

      if (index > this.dataImportTable.length - 1) {
        for (var i = 0; i < this.dataImportTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
      } else {
        var i = index;
        for (i; i < this.dataImportTable.length; i++) {
          if (this.$refs[`input${i}-${columnProp}`] !== undefined) {
            this.$refs[`input${i}-${columnProp}`][0].focus();
            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.dataImportTable.length) {
          this.focusNextInput(-1, columnProp);
        }
      }
    },

    //値がNULLまたはEmptyです
    isEmptyOrNull(item) {
      if (item == undefined || item == STR_EMPTY) {
        return true;
      } else {
        return false;
      }
    },

    //運賃(元/个)の計算：加工_加工単価(CNY),重量
    calDidMUTransportCostCny(didMUPriceCny, didUWeight) {
      if (didMUPriceCny <= 190) {
        return formatStringToWeight(didMUPriceCny * 0.05);
      } else if (didMUPriceCny > 190 && didMUPriceCny <= 500) {
        return formatStringToWeight(didMUPriceCny * 0.08);
      } else if (didMUPriceCny > 500 && didMUPriceCny < 700) {
        return formatStringToWeight(didMUPriceCny * 0.1);
      } else if (didMUPriceCny >= 700 && didMUPriceCny <= 1000) {
        return formatStringToWeight(didMUPriceCny * 0.11);
      } else if (didMUPriceCny > 1000) {
        if (this.isEmptyOrNull(didUWeight)) {
          didUWeight = 0;
        }
        return formatStringToWeight(didUWeight * 30);
      }
    },

    //運賃(元/个)の背景色：数量,加工単価(CNY),重量
    calDidMUTransportCostCnyColor(didProdQuantity, didMUPriceCny, didUWeight) {
      if (didProdQuantity >= 10) {
        //数量>＝10個：橙色
        return "bg-cell-editable";
      } else {
        if (didMUPriceCny == 0) {
          //数量<10個、加工_加工単価(CNY)= 0または空  :  赤色
          return "bg-cell-attention";
        } else if (didMUPriceCny > 0 && didMUPriceCny <= 1000) {
          //数量<10個、0<加工_加工単価(CNY)<=1000 : 白
          return "";
        } else if (didMUPriceCny > 1000) {
          if (this.isEmptyOrNull(didUWeight)) {
            //数量<10個、加工_加工単価(CNY)>1000、重量が空 : 赤色
            return "bg-cell-attention";
          } else {
            //数量<10個、加工_加工単価(CNY)>1000、重量が非空 : 白
            return "";
          }
        }
      }
    },

    // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
    //  入力可能のチェック
    inputEnableCheck(row, column) {
      //　「製品」以外の場合、「重量、運賃(CNY)、提成率(%)」が編集不可
      if (
        row.didType != t("resource.DATA_IMPORT.PRODUCT") &&
        (column.property == "didUWeight" ||
          column.property == "didMUTransportCostCny" ||
          column.property == "didMCommissionRate")
      ) {
        return true;
      }

      //　売価が編集不可
      if (column.property == "didUSalesPrice") {
        return true;
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      //　粗利率％が編集不可
      if (column.property == "didGrossMargin") {
        return true;
      }
      // ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑

      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 start↓
      var ASetDataFlg = this.dataImportTable.some(
        (row) => row.didProdUnit === UNIT_SET
      );

      var priceColumns = [
        "didMUPriceJpy",
        "didMUPriceCny",
        "didP1UPrice",
        "didP2UPrice",
        "didP3UPrice",
        "didMUTransportCostCny",
        "didUSetPrice",
      ];

      if (
        ASetDataFlg &&
        row.didProdUnit !== UNIT_SET &&
        priceColumns.includes(column.property)
      ) {
        return true;
      }
      // ADD 2025/11/20 ZLL 課題_251119顧客からの改善したい点への対応 end↑

      if (row.didMSupFactoryKbnStr != STR_EMPTY) {
        // 加工_仕入先が大連の場合、加工単価(JPY)が編集不可
        if (
          row.didMSupFactoryKbnStr == STR_DALIAN &&
          column.property == "didMUPriceJpy"
        ) {
          return true;
        }
        // 加工_仕入先が大連以外の場合、レート、加工単価(CNY)、運賃(CNY)、提成率(%)が編集不可
        if (
          row.didMSupFactoryKbnStr != STR_DALIAN &&
          (column.property == "didMUPriceCny" ||
            column.property == "didMExr" ||
            column.property == "didMCommissionRate" ||
            column.property == "didMUTransportCostCny")
        ) {
          return true;
        }
      } else {
        //　加工_仕入先が空の場合、加工単価(CNY)、加工単価(JPY)、運賃(CNY)、レート、，提成率(%)が編集不可
        if (
          column.property == "didMUPriceJpy" ||
          column.property == "didMUPriceCny" ||
          column.property == "didMExr" ||
          column.property == "didMCommissionRate" ||
          column.property == "didMUTransportCostCny"
        ) {
          return true;
        }
      }

      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
      // ミスミ仕入先の場合、ミスミ関連区分は「購入品、‐」以外の場合、確定売価が使用不可
      if (column.property == "didUSetPrice") {
        if (
          !this.isNotMisumiSupplier(row) &&
          this.misumiKbnIsNotPurchased(row.didMisumiKbn)
        ) {
          return true;
        }
      }
      // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑

      return false;
    },

    // 値が空のチェック
    checkIsNull(data) {
      return !data || data == null || data == undefined || data == STR_EMPTY;
    },
    // ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

    //テーブルで変更される可能性のある列の取得
    extract(data) {
      return data.map((item, index) => {
        return {
          index: index,
          didCusCode: item.didCusCode,
          // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 start↓
          // didCusUserCode: item.didCusUserCode,
          // DEL 2025/10/28 ZLL 課題_251024顧客からの改善したい点への対応 end↑
          didCusOrderNo: item.didCusOrderNo,
          didUWeight: item.didUWeight,
          didMSupCode: item.didMSupCode,
          didMExr: item.didMExr,
          didMUPriceJpy: item.didMUPriceJpy,
          didMUPriceCny: item.didMUPriceCny,
          didMCommissionRate: item.didMCommissionRate,
          didP1SupCode: item.didP1SupCode,
          didP1UPrice: item.didP1UPrice,
          didP2SupCode: item.didP2SupCode,
          didP2UPrice: item.didP2UPrice,
          didP3SupCode: item.didP3SupCode,
          didP3UPrice: item.didP3UPrice,
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
          // didGrossMargin: item.didGrossMargin,
          didGrossMargin: parseFloat(item.didGrossMargin).toFixed(2),
          // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
          didUSetPrice: item.didUSetPrice,
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
          didMUTransportCostCny: item.didMUTransportCostCny, //運賃(CNY)
          // ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑
          // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
          didMisumiKbn: item.didMisumiKbn, // ミスミ関連区分
          // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
        };
      });
    },

    //ダイアログを閉じる
    onCancel() {
      if (
        (!this.localIsAdd &&
          !cmpDetailData(
            this.cmpDetailResult,
            JSON.parse(JSON.stringify(this.extract(this.dataImportTable)))
          ) &&
          !this.userNullFlag) ||
        (this.localIsAdd && this.dataImportTable.length > 0)
      ) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },

    // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 start↓
    // 加工_仕入先の場合、クリア不可
    supCodeClearProc(prop) {
      if (prop === "didMSupCode") {
        return false;
      }
      return true;
    },
    // ADD 2025/03/28 ZLL 課題_250328顧客からの改善したい点への対応 end↑

    // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 start↓
    //ミスミ仕入先以外の判定　true:ミスミ仕入先以外　false:ミスミ仕入先
    isNotMisumiSupplier(row) {
      // if (column.property === "didMisumiKbn") {
      // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
      // ミスミ仕入先のチェック　⇒　関連仕入先区分のチェック
      // //仕入先略称
      // var supAbb = this.supplierList.find(
      //   (it) => it.supCode === row.didMSupCode
      // )?.supAbbreviation;

      // 仕入先関連区分の取得
      var supRelateFlag = this.supplierList.find(
        (it) => it.supCode === row.didMSupCode
      )?.supRelateFlag;

      //ミスミ仕入先以外の場合、ミスミ関連区分が編集不可
      // if (supAbb === undefined || !supAbb.includes(STR_MISUMI)) {
      if (supRelateFlag === undefined || supRelateFlag !== STR_ONE) {
        // UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑
        return true;
      } else {
        return false;
      }
    },

    // ミスミ関連区分表示項目の取得
    getMisumiKbnList() {
      var misumiKbnListTemp = this.misumiKbnList.filter((kbn) => {
        return kbn.value !== STR_ZERO;
      });

      return misumiKbnListTemp;
    },

    // 現在選択されている値が表示リストにない: true、ある：false
    hasHiddenSelection(row) {
      return !this.getMisumiKbnList().some(
        (item) => item.value === row.didMisumiKbn
      );
    },

    // 非表示オプションのデータの取得
    getHiddenOption(row) {
      const selectedItem = this.misumiKbnList.find(
        (item) => item.value === row.didMisumiKbn
      );

      return selectedItem;
    },

    //確定売価、処理1～3　使用可能・不可判定用
    //仕様から、「購入品、‐」以外：使用不可、その他：使用可能
    misumiKbnIsNotPurchased(misumiKbn) {
      return misumiKbn != STR_ZERO && misumiKbn != STR_ONE;
    },

    // ミスミ仕入先&&金額調整：true、以外：false
    isMisumiSupplierAndSupplemental(row) {
      if (!this.isNotMisumiSupplier(row) && row.didType === STR_SUPPLEMENTAL) {
        return true;
      }
      return false;
    },

    //ミスミ関連区分のchangeイベント
    changeSelectMisumiKbn(row, col) {
      this.dataImportTable.map((item) => {
        if (row.index == item.index) {
          if (col.property == "didMisumiKbn") {
            // 購入品以外の場合、確定売価が0に表示
            if (this.misumiKbnIsNotPurchased(row.didMisumiKbn)) {
              item.didUSetPrice = 0;
              // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓
              item.didUSalesPrice = 0;
              // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 end↑
            }
          }
        }
        return item;
      });
      this.dataProcess();
    },
    // ADD 2025/08/21 WZC 課題_ミスミ仕入先の関連対応 end↑
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
.el-form-item {
  margin-bottom: 5px;
}

.editCell {
  width: 100%;
  height: 17px;
  line-height: 0;
}

/* ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓ */
.combined-cell {
  display: flex;
  flex-direction: column; /* 上下に並べる */
  gap: 4px; /* 上下のコントロール間の間隔 */
}
/* ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑ */

::v-deep .el-table.table_common .el-table__fixed {
  height: auto !important;
  bottom: 16px;
}
</style>
